import React from "react";
import {Container} from "@mui/material";

const KdvOranlari = () => {
    return (
        <Container maxWidth="lg" sx={{py: 5}}>
            <div className="field-item even" property="content:encoded">
                <p align="center">
                    <span style={{ fontWeight: "bold" }}>GÜNCEL KDV ORANLARI</span>
                </p>
                <p align="center">
    <span style={{ fontWeight: "bold" }}>
      MAL VE HİZMETLERE UYGULANACAK KATMA DEĞER VERGİSİ
    </span>
                </p>
                <p align="center">
    <span style={{ fontWeight: "bold" }}>
      ORANLARININ TESPİTİNE İLİŞKİN KARAR (*)
    </span>
                </p>
                <p align="center">&nbsp;</p>
                <div align="center">
                    <table cellSpacing={0} cellPadding={0} border={1}>
                        <tbody>
                        <tr>
                            <td width={154} valign="top">
                                <p align="center">Resmî Gazete Tarihi</p>
                            </td>
                            <td width={154} valign="top">
                                <p align="center">Resmî Gazete Sayısı</p>
                            </td>
                            <td width={154} valign="top">
                                <p align="center">Karar Tarihi</p>
                            </td>
                            <td width={154} valign="top">
                                <p align="center">Karar Sayısı</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={154} valign="top">
                                <p align="center">30 Aralık 2007 PAZAR</p>
                            </td>
                            <td width={154} valign="top">
                                <p align="center">26742</p>
                            </td>
                            <td width={154} valign="top">
                                <p align="center">24/12/2007</p>
                            </td>
                            <td width={154} valign="top">
                                <p>2007/13033</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>
                    <span style={{ fontWeight: "bold" }}>Katma değer vergisi oranları</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>MADDE 1 –</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;Mal teslimleri ile
                    hizmet ifalarına uygulanacak katma değer vergisi oranları;&nbsp;&nbsp;&nbsp;{" "}
                    <br />
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;Ekli listelerde yer
                    alanlar hariç olmak üzere, vergiye tabi işlemler için,&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (7346 sayılı Cumhurbaşkanı Kararı ile değişen ibare. Yürürlük: 10/07/2023)
    </span>
                    &nbsp;% 20 <strong>(102)</strong>&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;Ekli (I) sayılı listede
                    yer alan teslim ve hizmetler için,&nbsp;% 1&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>c)</span>&nbsp;Ekli (II) sayılı listede
                    yer alan teslim ve hizmetler için,
                    <span style={{ fontWeight: "bold" }}>
      (7346 sayılı Cumhurbaşkanı Kararı ile değişen ibare. Yürürlük: 10/07/2023)
    </span>
                    &nbsp;% 10 <strong>(103)</strong>&nbsp;
                </p>
                <p>olarak tespit edilmiştir.</p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(2)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2011/2604 sayılı Kararname ile değişen sıra. Yürürlük: 27/12/2011)&nbsp;
    </span>
                    (I) sayılı listenin&nbsp;"B) DİĞER MAL VE HİZMETLER'' bölümünün&nbsp;16 ncı
                    ve 17 nci sıralarında sayılan işlemler hariç olmak üzere finansal kiralama
                    işlemlerinde, işleme konu olan malın tabi olduğu katma değer vergisi oranı
                    uygulanır.&nbsp; <span style={{ fontWeight: "bold" }}> (20) (83) </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(3)</span>&nbsp;(I) sayılı listenin "A)
                    GIDA MADDELERİ" bölümünde yer alan ürünlerden özel tüketim vergisine tabi
                    olanların tesliminde bu maddenin birinci fıkrasının (c) bendinde öngörülen
                    vergi oranı uygulanır. <strong>(84)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(4)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(5189 sayılı Cumhurbaşkanı Kararıyla kaldırılan bent;&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 14/02/2022</span>{" "}
                    <span style={{ fontWeight: "bold" }}> )&nbsp; </span> <strong>(85)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(5)</span>&nbsp;(I) sayılı listenin "B)
                    DİĞER MAL VE HİZMETLER'' bölümünün&nbsp;9 uncu sırasında yer alan
                    "kullanılmış" deyimi, 4760 sayılı Özel Tüketim Vergisi Kanununa göre özel
                    tüketim vergisine tabi olmayan taşıtları ifade eder. <strong>(86)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(6)&nbsp;</span>
                    <span style={{ textAlign: "justify" }}>
      <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        (29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 1.maddesi ile
        kaldırılan fıkra
      </span>{" "}
                        <span style={{ fontWeight: "bold" }}> ; </span>{" "}
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022;{" "}
      </span>
      <strong>
        Bu Kararın yürürlük tarihinden önce yapı ruhsatı alınmış veya kamu kurum
        ve kuruluşları ile bunların iştirakleri tarafından ihalesi yapılmış
        projeler kapsamında inşa edilen konutlar için 1 inci ve 4 üncü
        maddelerde kaldırılan veya değiştirilen hükümlerin uygulanmasına devam
        olunur.
      </strong>{" "}
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}> ) </span>{" "}
    </span>{" "}
                    <strong>(92)</strong>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      Mal ve hizmetleri tanımlama yetkisi
    </span>
                    &nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>MADDE 2 –&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;Bu Karar kapsamındaki
                    mal ve hizmetleri tanımlamaya Maliye Bakanlığı yetkilidir.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>Yürürlükten kaldırılan mevzuat</span>
                    &nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>MADDE 3 –</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;Mal teslimleri ve
                    hizmet ifalarına uygulanacak katma değer vergisi oranlarının tespit edilmesi
                    hakkındaki 17/7/2002 tarihli ve 2002/4480 sayılı Kararname ile bu
                    Kararnamede değişiklik yapan, 25/4/2003 tarihli ve 2003/5557 sayılı,
                    5/6/2003 tarihli ve 2003/5710 sayılı, 23/12/2003 tarihli ve 2003/6666
                    sayılı, 26/2/2004 tarihli ve 2004/6887 sayılı, 21/7/2004 tarihli ve
                    2004/7666 sayılı, 18/8/2004 tarihli ve 2004/7802 sayılı, 27/12/2004 tarihli
                    ve 2004/8301 sayılı, 6/3/2006 tarihli ve 2006/10138 sayılı, 26/6/2006
                    tarihli ve 2006/10620 sayılı, 25/5/2007 tarihli ve 2007/12143 sayılı
                    Kararnameler yürürlükten kaldırılmıştır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>Yürürlük&nbsp;</span>&nbsp;&nbsp;{" "}
                    <br />
                    <span style={{ fontWeight: "bold" }}>MADDE 4 –</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;Bu Kararın; finansal
                    kiralama işlemlerine ilişkin hükümleri Kararın yayımı tarihinden sonra
                    düzenlenen sözleşmeler için geçerli olmak üzere yayımı tarihinde, (II)
                    sayılı listenin "A) GIDA MADDELERİ"&nbsp; bölümünün 13/b, 14 ve 18/b
                    sıraları ile "B) DİĞER MAL VE HİZMETLER" bölümünün 24 üncü ve 25 inci
                    sıraları 1/1/2008 tarihinde, diğer hükümleri yayımını izleyen gün yürürlüğe
                    girer.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>Yürütme</span>&nbsp;&nbsp; <br />
                    <span style={{ fontWeight: "bold" }}>MADDE 5 –</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;Bu Karar hükümlerini
                    Maliye Bakanı yürütür.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 1–&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp;15/7/2012&nbsp;tarihine
                    kadar uygulanmak üzere; okul, sağlık hizmet tesisi ve öğrenci yurdu olarak
                    kullanılmak amacıyla inşa edilen prefabrik yapı teslimlerinde katma değer
                    vergisi oranı % 1 olarak belirlenmiştir.&nbsp;
                    <span style={{ fontWeight: "bold" }}>(21)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 2-&nbsp;</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp; Bu Kararın 1 inci
                    maddesinin birinci fıkrasının (a) bendinde belirtilen vergi oranına tabi
                    konutların,&nbsp; 30/9/2017&nbsp;
                    <span style={{ fontWeight: "bold" }}>(49)</span>&nbsp;tarihine kadar (bu
                    tarih dahil) teslimlerinde, aynı fıkranın (c) bendinde belirtilen vergi
                    oranı uygulanır.&nbsp;<span style={{ fontWeight: "bold" }}>(45)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 3- (1)</span>&nbsp;Bu
                    Kararın 1 inci maddesinin birinci fıkrasının (a) bendinde belirtilen vergi
                    oranına tabi konutlar ile işyerlerinin (bina ve/veya bağımsız bölüm şeklinde
                    olanlar)&nbsp;<span style={{ fontWeight: "bold" }}>(57)</span>
                    &nbsp;31/12/2019&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (59) (62) (63) </span> &nbsp;tarihine
                    kadar (bu tarih dahil) teslimlerinde, aynı fıkranın (c) bendinde belirtilen
                    vergi oranı uygulanır.<span style={{ fontWeight: "bold" }}>&nbsp;(56)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 4-</span>&nbsp;(1) Büyük
                    ve küçükbaş hayvanların, 10/9/2018 tarihine kadar (bu tarih dahil) kamu
                    menfaatine yararlı dernekler ve Cumhurbaşkanınca vergi muafiyeti tanınan
                    vakıflara teslimlerinde, bu Kararın 1 inci maddesinin (b) bendinde
                    belirtilen vergi oranı uygulanır.
                    <span style={{ fontWeight: "bold" }}>&nbsp;(58)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 5-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2278 sayılı Cumhurbaşkanı Kararıyla eklenen geçici madde; Yürürlük:
      1.04.2020)&nbsp;
    </span>
                    Hava yolu ile yolcu taşımacılığı hizmetlerine, 30/6/2020 tarihine kadar (bu
                    tarih dahil), bu Kararın 1 inci maddesinin birinci fıkrasının (b) bendinde
                    belirtilen katma değer vergisi oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 6-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2812 sayılı Cumhurbaşkanı Kararıyla eklenen geçici madde; Yürürlük:
      31.07.2020) (4312 sayılı Cumhurbaşkanı Kararıyla değişen ibare;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> Yürürlük: 01.08.2021 </span>{" "}
                    <span style={{ fontWeight: "bold" }}>)&nbsp;(1)</span>&nbsp;30/9/2021
                    <span style={{ fontWeight: "bold" }}>(77)</span>&nbsp;tarihine kadar (bu
                    tarih dahil);
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;İşyeri kiralama hizmeti,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;Kongre, konferans,
                    seminer, konser, fuar ve lunapark giriş ücretleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>c)</span>&nbsp;Düğün, nikah, balo ve
                    kokteyl salonlarında verilen organizasyon hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>ç)</span>&nbsp;Berberlik ve kuaförlük
                    hizmetleri ile güzellik salonunda verilen hizmetler,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>d)</span>&nbsp;Terzilik, giyim eşyası
                    ve ev tekstil ürünlerinin onarım ve tamiratı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>e)</span>&nbsp;Ayakkabı ve deri
                    eşyaların onarımı ile ayakkabı boyama hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>f)</span>&nbsp;Kuru temizleme,
                    çamaşırhane, giyim eşyası ve diğer tekstil ürünlerini ütüleme hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>g)</span>&nbsp;Halı ve kilim yıkama
                    hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>ğ)</span>&nbsp;Bisiklet, motosiklet ve
                    motorlu bisikletlerin bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>h)</span>&nbsp;Evde kullanılan
                    elektrikli cihazların (buzdolabı, fırın, çamaşır makinesi, bulaşık makinesi,
                    fırın, klima vb.) bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>ı)</span>&nbsp;Tüketici elektroniği
                    ürünlerinin (TV, radyo, CD/DVD oynatıcıları, ev tipi video kameralar vb.)
                    bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>i)</span>&nbsp;Evde kullanılan ısıtma
                    ürünlerinin (termosifon, şofben, banyo kazanı, kombi vb.) (merkezi ısıtma
                    kazanları hariç) bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>j)</span>&nbsp;Ev ve bahçe gereçlerinin
                    bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>k)</span>&nbsp;Mobilyaların ve ev
                    döşemelerinin bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>l)</span>&nbsp;Bilgisayarların,
                    iletişim araç ve gereçlerinin, saatlerin bakım ve onarımı (malzemeler
                    hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>m)</span>&nbsp;Müzik aletlerinin bakım
                    ve onarımı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>n)</span>&nbsp;Çilingirlik ve anahtar
                    çoğaltma hizmetleri ile hamallık hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>o)</span>&nbsp;Motorlu kara
                    taşıtlarının yağlanması, yıkanması, cilalanması hizmetleri ile bunlara ait
                    koltuk ve döşemelerin bakım ve onarımı (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>ö)</span>&nbsp;Hane sakinlerine verilen
                    konut bakım, onarım, boya ve temizlik hizmetleri (malzemeler hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>p)</span>&nbsp;Ekli II sayılı listenin
                    "B) DİĞER MAL VE HİZMETLER" bölümünün 24 üncü sırası kapsamı dışındaki
                    yeme-içme hizmetleri (alkollü içeceklere isabet eden kısmı hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>r)</span>&nbsp;Yolcu taşımacılığı
                    hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>s)</span>&nbsp;Ekli II sayılı listenin
                    "A) GIDA MADDELERİ" bölümünün 4 üncü sırasında yer alan mallar hariç olmak
                    üzere, 30/12/2019 tarihli ve 1951 sayılı Cumhurbaşkanı Kararının eki
                    İstatistik Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 6 no.lu
                    fasılında yer alan süs bitkileri ile çiçek teslimleri,
                </p>
                <p>
                    için 1 inci maddenin birinci fıkrasının (c) bendinde belirtilen vergi oranı
                    uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (4312 sayılı Cumhurbaşkanı Kararıyla değişen ibare;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 01.08.2021</span>&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> )&nbsp;&nbsp; </span>{" "}
                    <span style={{ fontWeight: "bold" }}>(2)</span>&nbsp;30/9/2021
                    <span style={{ fontWeight: "bold" }}>(77)</span>&nbsp;tarihine kadar (bu
                    tarih dahil);
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;Ekli II sayılı listenin
                    "B) DİĞER MAL VE HİZMETLER'' bölümünün 16 ncı sırasında yer alan giriş
                    ücretleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;Ekli II sayılı listenin
                    "B) DİĞER MAL VE HİZMETLER" bölümünün 24 üncü sırasında yer alan yeme-içme
                    hizmetleri,
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      c) (4062 sayılı Cumhurbaşkanı Kararıyla kaldırılan bent;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 01.06.2021</span>
                    <span style={{ fontWeight: "bold" }}>)</span>(75)
                </p>
                <p>
                    için 1 inci maddenin birinci fıkrasının (b) bendinde belirtilen vergi oranı
                    uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 7-</span>(1) Üniversite ve
                    yüksekokullar ile 5580 sayılı Özel Öğretim Kurumları Kanunu, 2828 sayılı
                    Sosyal Hizmetler Kanunu ve 573 sayılı Özel Eğitim Hakkında Kanun Hükmünde
                    Kararname kapsamında 1 Eylül 2020 ila 30 Haziran 2021 tarihleri arasında (bu
                    tarihler dahil) verilen eğitim ve öğretim hizmetleri için bu Kararın 1 inci
                    maddesinin birinci fıkrasının (b) bendinde belirtilen vergi oranı
                    uygulanır.&nbsp;<span style={{ fontWeight: "bold" }}>(71)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 8-&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (3318 sayılı Cumhurbaşkanı Kararıyla eklenen geçici madde; Yürürlük:
      23.12.2020)&nbsp;
    </span>
                    (1) Sağlık Bakanlığınca onaylanan Covid-19 aşılarının, 31/12/2022 tarihine
                    kadar (bu tarih dahil) tesliminde, bu kararın 1 inci maddesinin birinci
                    fıkrasının (b) bendinde belirtilen vergi oranı uygulanır.&nbsp;
                    <span style={{ fontWeight: "bold" }}>(81)</span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      GEÇİCİ MADDE 9- (1)
      <span>
        (3931 sayılı Cumhurbaşkanı Kararıyla eklenen geçici madde; Yürürlük:
        01.06.2021)
      </span>
        &nbsp;{" "}
    </span>{" "}
                    <b>
                        (4312 sayılı Cumhurbaşkanı Kararı ile değişen ibare; Yürürlük: 01.08.2021)
                    </b>
                    30/9/2021<span style={{ fontWeight: "bold" }}>(78)</span>&nbsp;tarihine
                    kadar (bu tarih dahil) ekli II sayılı listenin 'B) DİĞER MAL VE HİZMETLER'
                    bölümünün 25 inci sırasında yer alan geceleme hizmetleri için 1 inci
                    maddenin birinci fıkrasının (b) bendinde belirtilen vergi oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>GEÇİCİ MADDE 10-</span>{" "}
                    <span style={{ fontWeight: "bold" }}>
      <span>
        (6830 sayılı Cumhurbaşkanı Kararıyla değişen geçici madde; Yürürlük:
        23.02.2023)
      </span>
                        &nbsp;{" "}
    </span>{" "}
                    (1) Prefabrik yapı ile konteynerlerin 31/12/2023 tarihine kadar (bu tarih
                    dahil) tesliminde (kurulum ve montaj işleri dahil), bu Kararın 1 inci
                    maddesinin birinci fıkrasının (b) bendinde belirtilen vergi oranı uygulanır.{" "}
                    <strong>(101) </strong>
                </p>
                <p align="center">
                    <span style={{ fontWeight: "bold" }}>(I) SAYILI LİSTE</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>A) GIDA MADDELERİ (82)</span>{" "}
                </p>
                <p />
                <p />
                <p>
                    22/12/2006 tarihli ve 2006/11437 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>1 - a)</span>&nbsp;01.01, 01.02, 01.03,
                    01.04, 01.05&nbsp;pozisyonlarında yer alan hayvanlar ile 01.06 pozisyonunda
                    yer alan (yalnız tavşanlar, geyikler, dağ keçisi, keklik, devekuşu,
                    bıldırcın, çulluk, yabani ördek ve kazlar, sülün, beç tavuğu)
                    hayvanlar,&nbsp;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;02.07 pozisyonu ve
                    0209.90.00.00.00 gümrük tarife istatistik pozisyon numarasında yer alan
                    mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>c)</span>&nbsp;3 no.lu faslında yer
                    alan mallar (0301.10&nbsp;&nbsp;pozisyonunda yer alan süs balıkları hariç),{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>2-</span>&nbsp;4 no.lu faslında yer
                    alan mallar (0408.11.20.00.00, 0408.19.20.00.00, 0408.91.20.00.00,
                    0408.99.20.00.00 pozisyonlarında yer alan mallar hariç),{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>3-</span>&nbsp;5 no.lu faslın 0504.00
                    pozisyonunda yer alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>4-</span>&nbsp;6 no.lu faslın
                    0601.20.10.00.11, 0601.20.10.00.12, 0602.10, 0602.20, 0602.90.10.00.00,
                    0602.90.20.00.00, 0602.90.30.00.00 pozisyonlarında yer alan mallar,&nbsp;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>5-</span>&nbsp;7 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>6-</span>&nbsp;8 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>7-</span>&nbsp;9 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>8-</span>&nbsp;10 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>9-</span>&nbsp;11 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>10-</span>&nbsp;12 no.lu faslında yer
                    alan mallar (yalnız; sebze ve meyveler, bunların tohum, çekirdek ve
                    sporları, nane, şeker kamışı, pamuk tohumu ve çiğiti, yağlı tohum ve
                    meyvelerin un ve kaba unları),{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>11-</span>&nbsp;15 no.lu faslında yer
                    alan yağlardan insan gıdası olarak kullanılmaya elverişli olanlar ile
                    bunların üretiminde kullanılmaya elverişli olan ham yağlar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>12-</span>&nbsp;16 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>13-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;17 no.lu faslında yer
                    alan mallar (1704.90.30.00.00 pozisyonunda yer alanlar hariç),&nbsp;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;1704.90.30.00.00
                    pozisyonunda yer alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>14-</span>&nbsp;18 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>15-</span>&nbsp;19 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>16-</span>&nbsp;20 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>17-</span>&nbsp;21 no.lu faslında yer
                    alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>18-</span>&nbsp;22 no.lu faslında yer
                    alan mallardan yalnız;&nbsp;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;22.01, 2202.10.00.00.19,
                    2202.90, 2204.30, 2209.00.91.00.00, 2209.00.99.00.00 pozisyonlarında yer
                    alanlar,&nbsp;{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;2202.10.00.00.11,
                    2202.10.00.00.12, 2202.10.00.00.13 pozisyonlarında yer alanlar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>19-</span>&nbsp;23 no.lu faslın
                    2306.90.11.00.11, 2306.90.11.00.19, 2306.90.19.00.11, 2306.90.19.00.19
                    pozisyonlarında yer alan mallar,{" "}
                </p>
                <p />
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>20-</span>&nbsp;25 no.lu faslın
                    2501.00.91.00.11, 2501.00.91.00.12, 2501.00.91.00.19 pozisyonlarında yer
                    alan mallar
                </p>
                <p
                    className="MsoNormal"
                    style={{
                        marginBottom: "6.0pt",
                        textAlign: "justify",
                        lineHeight: "normal"
                    }}
                >
                    <span style={{ fontWeight: "bold" }}>B) DİĞER MAL VE HİZMETLER</span>
                </p>
                <p
                    className="MsoNormal"
                    style={{
                        marginBottom: "6.0pt",
                        textAlign: "justify",
                        lineHeight: "normal"
                    }}
                >
                    <span style={{ fontWeight: "bold" }}>1-&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (5189 sayılı Cumhurbaşkanı Kararıyla kaldırılan bent;&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 14/02/2022</span>{" "}
                    <span style={{ fontWeight: "bold" }}> )&nbsp; </span>{" "}
                    <span style={{ fontWeight: "bold" }}>(88)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>2- a)</span>&nbsp;Mazı, palamut, kendir
                    tohumu, kanola (kolza), kitre,&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;Meyan kökü, meyan balı,
                    meyan hülasası, çöven, sumak yaprağı, defne yaprağı, ıhlamur, kekik,
                    adaçayı, mahlep, kimyon, susam, anason, haşhaş tohumu, rezene tohumu,
                    süpürge teli ve tohumu ile bunlardan mamul süpürgeler, kapari (kebere),
                    harnup (keçiboynuzu), harnup çekirdeği, zerdali çekirdeği, kayısı çekirdeği,
                    kişniş, acıbadem, kuzu göbeği mantar, şeker pancarı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>3-&nbsp;</span>Buğday, bulgur, arpa,
                    mısır, yulaf, çavdar, darı, çeltik, pirinç, soya, kuru fasulye, kuru
                    barbunya, kuru bakla, nohut, mercimek, patates, kuru soğan, sarımsak,
                    zeytin, zeytinyağı, küçük ve büyükbaş hayvanlar (arılar dahil), 20/12/2010
                    tarihli ve 2010/1180 sayılı Bakanlar Kurulu Kararı ile yürürlüğe konulan
                    İstatistik Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 2 no.lu
                    faslında yer alan mallar (02.07 pozisyonu ve 0209.90.00.00.00 gümrük tarife
                    istatistik pozisyon numarasında yer alan mallar hariç), tavuk
                    yumurtası,&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>4-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (5189 sayılı Cumhurbaşkanı Kararıyla kaldırılan bent;&nbsp;Yürürlük:
      14/02/2022)&nbsp;(89)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>5-</span>&nbsp;Tarım ve Orman Bakanlığı
                    tarafından sertifikalandırılan tohumluk ve fidanlar, <strong>(93)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>6-</span>
                    <span
                        style={{
                            fontSize: "11.0pt",
                            lineHeight: "115%",
                            fontFamily: '"Calibri",sans-serif',
                            msoAsciiThemeFont: "minor-latin",
                            msoFareastFontFamily: "Calibri",
                            msoFareastThemeFont: "minor-latin",
                            msoHansiThemeFont: "minor-latin",
                            msoBidiFontFamily: '"Times New Roman"',
                            msoBidiThemeFont: "minor-bidi",
                            msoAnsiLanguage: "TR",
                            msoFareastLanguage: "EN-US",
                            msoBidiLanguage: "AR-SA"
                        }}
                    >
      &nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (5189 sayılı Cumhurbaşkanı Kararıyla kaldırılan bent;&nbsp;{" "}
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 14/02/2022</span>
                    <span style={{ fontWeight: "bold" }}>)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>(90)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>7-</span>&nbsp;Suni döllenme için
                    dondurulmuş hayvan spermaları,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>8-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (18/12/2018 tarihli ve 475 sayılı Cumhurbaşkanı Kararının 1 inci
      maddesiyle değiştirilen sıra. Yürürlük: 1/1/2019)
    </span>
                    &nbsp;Gazete ve dergiler (Bu yayınların elektronik ortamda satışı,
                    elektronik gazete ve dergi okuyucu, tablet ve benzerlerinin teslimi ile
                    21/6/1927 tarihli ve 1117 sayılı Kanun hükümlerine göre poşetlenerek
                    satılanların tesliminde, bu Kararın 1 inci maddesinin birinci fıkrasının (a)
                    bendinde belirtilen vergi oranı uygulanır.),&nbsp;
                    <span style={{ fontWeight: "bold" }}>(60)&nbsp;</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>9-</span>&nbsp;Aşağıda tanımları
                    yapılan motorlu taşıtlardan yalnız "kullanılmış" olanlar,"Türk Gümrük Tarife
                    Cetvelinin 8701.90.50.00.00 Kullanılmış olanlar ile
                    <span style={{ fontWeight: "bold" }}>&nbsp;(10) (50)</span>&nbsp;87.03
                    pozisyonundaki binek otomobilleri ve esas itibariyle insan taşımak üzere
                    imal edilmiş diğer motorlu taşıtlar (87.02 pozisyonuna girenler hariç)
                    (steyşın vagonlar ve yarış arabaları dahil). [(Yalnız binek otomobilleri,
                    steyşın vagonlar, yarış arabaları, arazi taşıtları, jipler, vb., motorlu
                    karavanlar, elektrik, gaz, güneş enerjili vb. motorlu taşıtlar,
                    "8703.10.11.00.00 özellikle kar üzerinde hareket etmek için dizayn edilmiş
                    sıkıştırma ateşlemeli içten yanmalı pistonlu motorlu olanlar (dizel veya
                    yarı dizel) veya kıvılcım ateşlemeli içten yanmalı pistonlu motorlu
                    taşıtlar","8703.10.18.00.00 diğerleri"] [Ambulanslar, mahkum taşımaya mahsus
                    arabalar, para arabaları, cenaze arabaları, itfaiye öncü arabaları gibi özel
                    amaçla yapılmış motorlu taşıtlar hariç.] (Katma Değer Vergisi Kanununun 30/b
                    maddesine göre binek otomobillerinin alımında yüklenilen katma değer
                    vergisini indirim hakkı bulunan mükelleflerin, bu araçları tesliminde bu
                    Kararın 1 inci maddesinin (a) bendinde öngörülen vergi oranı
                    uygulanır.&nbsp;
                    <strong>
                        {" "}
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 3.maddesi ile
        değiştirilen cümle
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        Yürürlük: 01/04/2022)
      </span>
                    </strong>{" "}
                    İkinci el motorlu kara taşıtı ticaretiyle iştigal eden mükelleflerce bu
                    Kararın 1 inci maddesinin birinci fıkrasının (a) bendinde belirtilen vergi
                    oranı uygulanarak satın alınan araçların teslimi ile özel matrah uygulanarak
                    yapılan teslimlerde, bu Kararın 1 inci maddesinin birinci fıkrasının (a)
                    bendinde belirtilen vergi oranı uygulanır.<strong>(94)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>10-</span>&nbsp;Türk Gümrük Tarife
                    Cetvelinin 2713.20.00.00.11 pozisyonunda yer alan penetrasyon asfalt
                    (cut-back asfaltlar hariç) teslimi,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>11-</span>&nbsp;
                    <strong>
      <span style={{ textAlign: "justify" }}>
        <strong>
          (
          <span style={{ textAlign: "justify", fontWeight: "bold" }}>
            29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 4.maddesi ile
            değiştirilen ibare
          </span>
          <span style={{ fontWeight: "bold" }}>;</span>
          <span style={{ textAlign: "justify", fontWeight: "bold" }}>
            &nbsp;Yürürlük: 01/04/2022
            <strong>
              ; Bu Kararın yürürlük tarihinden önce yapı ruhsatı alınmış veya
              kamu kurum ve kuruluşları ile bunların iştirakleri tarafından
              ihalesi yapılmış projeler kapsamında inşa edilen konutlar için 1
              inci ve 4 üncü maddelerde kaldırılan veya değiştirilen hükümlerin
              uygulanmasına devam olunur.
            </strong>{" "}
          </span>{" "}
        </strong>{" "}
      </span>{" "}
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>)</span>{" "}
                    </strong>{" "}
                    16/5/2012 tarihli ve 6306 sayılı Afet Riski Altındaki Alanların
                    Dönüştürülmesi Hakkında Kanun kapsamında rezerv yapı alanı ve riskli alan
                    olarak belirlenen yerler ile riskli yapıların bulunduğu yerlerde dönüşüm
                    projeleri çerçevesinde yapılan konutların net alanının 150 m2'ye kadar olan
                    kısmı <strong>(95)</strong> ile belediyeler, il özel idareleri, Toplu Konut
                    İdaresi Başkanlığı ve bunların % 51 veya daha fazla hissesine ya da
                    yönetiminde oy hakkına sahip oldukları işletmeler tarafından konut yapılmak
                    üzere projelendirilmiş arsaların (sosyal tesisler için ayrılan bölümler
                    dahil) net alanı 150 m2'nin altındaki konutlara isabet eden kısmı,
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      12- (30/4/2019 tarihli ve 1013 sayılı Cumhurbaşkanı Kararının eki Kararın
      1 inci maddesiyle değiştirilen sıra. Yürürlük: 1/5/2019)
    </span>
                    &nbsp;Konut yapı kooperatifleri ile Darülaceze Başkanlığına yapılan inşaat
                    taahhüt işleri,&nbsp;<span style={{ fontWeight: "bold" }}>(65)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>13-</span>&nbsp;Kanunla kurulmuş sosyal
                    güvenlik kuruluşları ve belediyelere yapılan sadece net alanı 150 m2'ye
                    kadar konutlara ilişkin inşaat taahhüt işleri.&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (29/01/2021 tarihli ve 3470 sayılı Cumhurbaşkanı Kararı ile eklenen ifade.
      Yürürlük: 30/01/2021)&nbsp;
    </span>
                    6306 sayılı Kanun kapsamında riskli yapıların bulunduğu yerlerde dönüşüm
                    projeleri çerçevesinde taşınmaz maliklerine ait mevcut inşaat alanının bir
                    buçuk katına kadar olan yeni inşaat alanında yapılacak olan konutlara
                    ilişkin inşaat taahhüt işleri,&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (73) </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>14-</span>&nbsp;Cenaze hizmetleri.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>15-</span>&nbsp;3065 sayılı Katma Değer
                    Vergisi Kanununun 13 üncü maddesinin birinci fıkrasının (a) bendi uyarınca
                    teslimleri katma değer vergisinden istisna olan araçların, faaliyetleri
                    kısmen veya tamamen bu araçların kiralanması veya çeşitli şekillerde
                    işletilmesi olan mükelleflere kiralanması hizmeti,
                    <span style={{ fontWeight: "bold" }}>&nbsp;(5)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>16-</span>&nbsp;3065 sayılı Katma Değer
                    Vergisi Kanununun 13 üncü maddesinin birinci fıkrasının (d) bendi uyarınca
                    Yatırım Teşvik Belgesi sahibi mükelleflere belge kapsamındaki makine ve
                    teçhizatın, 3226 sayılı Finansal Kiralama Kanununa göre finansal kiralama
                    şirketleri tarafından kiralanması,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(18)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>17-</span>&nbsp;&nbsp;20/12/2010 tarih
                    ve 2010/1180 sayılı Bakanlar Kurulu Kararı ile yürürlüğe konulan İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin;&nbsp;
                    <span style={{ fontWeight: "bold" }}>(19)</span>
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.02</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Buhar kazanları (aynı zamanda alçak basınçlı su buharı da üretebilen
                                merkezi ısıtma için sıcak su kazanları hariç); kızgın su kazanları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.03</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>Merkezi ısıtma kazanları (84.02 pozisyonundakiler hariç):</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.04</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                84.02 veya 84.03 Pozisyonlarındaki kazanlarla birlikte kullanılmaya
                                mahsus yardımcı cihazlar (ekonomizörler, kızgın su hasıl eden, kurum
                                temizleme ve gaz tasarruf cihazları gibi); su buharı veya diğer
                                buhar güç üniteleri için kondansörler:&nbsp;
                                <span style={{ fontWeight: "bold" }}>(50)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.17</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Sanayi veya laboratuvarlara mahsus elektrikli olmayan fırınlar ve
                                ocaklar (çöp yakma fırınları dahil):
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8418.61.00.00.00</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Isı pompaları ( 84.15 pozisyonunda yer alan klima cihazları hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8418.69</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>Diğerleri (Diğer soğutucu veya dondurucu cihazlar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.19</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Isı değişikliği yoluyla (özellikle ısıtma, pişirme, kavurma,
                                damıtma, rektifiye etme, steril hale koyma, pastörize etme,
                                etüvleme, kurutma, buharlaştırma, kondanse etme veya soğutma gibi)
                                maddelerin işlenmesi için makinalar ve tesis veya laboratuvar
                                cihazları (ısıtması elektrikle olsun olmasın) (85.14 pozisyonundaki
                                ocaklar, fırınlar ve diğer cihazlar hariç)&nbsp; (ev işlerinde
                                kullanılmaya mahsus makina ve cihazlar hariç) elektrikli olmayan
                                şofbenler ve diğer su ısıtıcıları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.20</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Kalenderler ve diğer hadde makinaları (metal veya cam hadde
                                makinaları hariç) ve bu makinaların silindirleri:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.21</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Santrifüjler (santrifüj kurutma makinaları dahil); sıvıların veya
                                gazların filtre edilmesine veya arıtılmasına mahsus makina ve
                                cihazlar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.24</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Sıvı veya toz halindeki maddeleri püskürtmeye, dağıtmaya veya
                                pülverize etmeye mahsus mekanik cihazlar (el ile kullanılan türde
                                olsun olmasın); yangın söndürme cihazları (doldurulmuş olsun
                                olmasın); püskürtme tabancaları ve benzeri cihazlar; buhar veya kum
                                püskürtme makinaları ve benzeri püskürtme makinaları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.26</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Gemi vinçleri ("derricks"); vinçler ("cranes") (taşıyıcı halatlı
                                vinçler dahil); hareketli kaldırma çerçeveleri, şasisi "straddle"
                                tipi olan ayak mesafeleri ayarlanabilen lastik tekerlekli
                                taşıyıcılar ve vinçli yük arabaları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.28</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Kaldırma, elleçleme, yükleme veya boşaltma işlerine mahsus diğer
                                makina ve cihazlar (asansörler, yürüyen merdivenler, konveyörler,
                                teleferikler gibi):
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.29</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Kendinden hareketli buldozerler, angledozerler, greyderler, toprak
                                tesviyesine mahsus makinalar, skreyperler, mekanik küreyiciler,
                                ekskavatörler, küreyici yükleyiciler, sıkıştırma işini tokmaklamak
                                suretiyle yapan makinalar ve yol silindirleri:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.30</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Toprağın, minerallerin veya cevherlerin taşınması, yayılması,
                                tesviyesi, sıyrılması, kazılması, sıkıştırılması, bastırılıp
                                sıkıştırılması, çıkarılması veya delinmesine mahsus diğer makina ve
                                cihazlar; kazık varyosları ve kazık sökme makinaları; kar
                                küreyicileri ve püskürtücüleri:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.32</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Toprağı hazırlamaya, işlemeye ve ekmeye mahsus tarla ve bahçe
                                tarımında veya ormancılıkta kullanılan makina ve cihazlar;
                                çimenlikler ve spor sahaları için silindirler:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.33</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Tarım ürünlerinin hasat ve harman edilmesine mahsus makina ve
                                cihazlar (ot ve saman balyalamaya mahsus olanlar dahil); çim ve
                                çayır biçme makina ve cihazları; yumurtaları, meyvaları ve diğer
                                tarım ürünlerini ağırlık ve büyüklüklerine göre ayıran ve temizleyen
                                makina ve cihazlar (84.37 pozisyonundaki makina ve cihazlar hariç):
                                - Çim biçme makina ve cihazları
                                <span style={{ fontWeight: "bold" }}>&nbsp;(50)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.34</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Süt sağma makinaları ve sütçülükte kullanılan makina ve cihazlar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.35</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Şarap, elma şarabı, meyva suları veya benzeri içeceklerin imaline
                                mahsus presler, fulvarlar ve benzeri makina ve cihazlar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.36</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Tarla ve bahçe tarımına, ormancılığa, kümes hayvancılığına veya
                                arıcılığa mahsus diğer makina ve cihazlar (mekanik veya termik
                                tertibatlı çimlendirmeye mahsus olanlar dahil); kümes hayvancılığına
                                mahsus civciv çıkartma ve büyütme makina ve cihazları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.37</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Tohumların, hububatın, kuru baklagillerin temizlenmesine, tasnif
                                edilmesine veya ayıklanmasına mahsus makina ve cihazlar; kuru
                                baklagillerin veya hububatın öğütülmesine veya işlenmesine mahsus
                                makina ve cihazlar (çiftlik tipi makina ve cihazlar hariç):
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.38</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Bu fasılın diğer pozisyonlarında yer almayan veya belirtilmeyen
                                yiyecek ve içeceklerin sınai amaçlarla hazırlanması veya imaline
                                mahsus makina ve cihazlar (hayvansal, bitkisel sabit katı veya sıvı
                                yağların çıkarılmasına veya hazırlanmasına mahsus olanlar hariç):
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.51</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Dokumaya elverişli ipliklerin, mensucatın veya dokumaya elverişli
                                madde mamullerinin yıkanması, temizlenmesi, sıkılması, kurutulması,
                                ütülenmesi, preslenmesi suretiyle ütülenmesi (ısı ile yapıştıran
                                presler dahil), ağartılması, boyanması, aprelenmesi, finisajı,
                                emdirilmesine mahsus makina ve cihazlar (84.50 pozisyonundakiler
                                hariç) ve zemin kaplamalarının imalatında kullanılan (linoleum gibi)
                                mensucat veya diğer mesnetlere pasta kaplama makinaları; mensucatı
                                top halinde sarmaya, açmaya, katlamaya, kesmeye veya şekilli kesmeye
                                mahsus makinalar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.55</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>Metalleri haddeleme makinaları ve bunların silindirleri:</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.68</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Lehim ve kaynak yapmaya mahsus makina ve cihazlar (kesmeye elverişli
                                olsun olmasın) (85.15 pozisyonundakiler hariç); gazla çalışan satıh
                                tavlamaya mahsus makina ve cihazlar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.74</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Toprak, taş, cevher veya katı haldeki diğer mineral maddeleri (toz
                                ve hamur halinde olanlar dahil) tasnif etmeye, elemeye, ayırmaya,
                                yıkamaya, kırmaya, öğütmeye, karıştırmaya veya yoğurmaya mahsus
                                makina ve cihazlar; mineral katı yakıtları, seramik hamurlarını,
                                sertleşmemiş çimentoyu, alçıyı ve toz veya hamur halindeki diğer
                                mineral maddeleri aglomere etmeye, kalıba dökmeye veya bunlara şekil
                                vermeye mahsus makina ve cihazlar; kumdan dökümhane kalıpları
                                yapmaya mahsus makinalar:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={112} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>85.01</span>
                            </p>
                        </td>
                        <td width={2184} valign="bottom">
                            <p>
                                Elektrik motorları ve jeneratörler [elektrik enerjisi üretim
                                (elektrojen) grupları hariç] :
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8502.11</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Çıkış gücü 75 kVA.yı geçmeyenler (Sıkıştırma ateşlemeli, içten
                                yanmalı, pistonlu motorlu (dizel veya yarı dizel) elektrik enerjisi
                                üretim (elektrojen) grupları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(33)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8502.12</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Çıkış gücü 75 kVA.yı geçen fakat 375 kVA.yı geçmeyenler&nbsp;
                                (Sıkıştırma ateşlemeli, içten yanmalı, pistonlu motorlu (dizel veya
                                yarı dizel) elektrik enerjisi üretim (elektrojen) grupları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(33)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8502.13</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Çıkış gücü 375 kVA.yı geçenler&nbsp; (Sıkıştırma ateşlemeli, içten
                                yanmalı, pistonlu motorlu (dizel veya yarı dizel) elektrik enerjisi
                                üretim (elektrojen) grupları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(33)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8502.20</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Kıvılcım ateşlemeli, içten yanmalı, pistonlu motorlu elektrik
                                enerjisi üretim&nbsp; (elektrojen) grupları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(33)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8502.31</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Rüzgar çıkış gücü ile çalışanlar (Çıkış gücü 50 kVA ve bunun
                                üzerinde olan fakat 500 kVA.yı geçmeyenler)&nbsp;
                                <span style={{ fontWeight: "bold" }}>
              (2015/7205 sayılı BKK ile değiştirilen satır. Yürürlük :
              31/01/2015) (33) &nbsp;(38)
            </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>85.04</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Elektrik transformatörleri, statik konvertörler (örneğin;
                                redresörler) ve endüktörler:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>85.14</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Sanayi veya laboratuvarlarda kullanılan elektrik ocak ve fırınları
                                (endüksiyon veya dielektrik kaybı yoluyla çalışanlar dahil);
                                endüksiyon veya dielektrik kaybı yoluyla termik işlemlerde
                                kullanılmaya mahsus diğer sanayi veya laboratuvar cihazları:
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.06</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Buhar türbinleri&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.10</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Su türbinleri, su çarkları ve bunlar için regülatörler&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.11</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Turbojetler, turbopropellerler ve diğer gaz türbinleri&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8413.19.00.20.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Fiyat ve miktar gösteren tertibatı olan dağıtım pompaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8413.19.00.90.11</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Gıda maddeleri için miktar gösteren dağıtım pompaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8413.19.00.90.12</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Miktar gösteren tertibatı olan diğer dağıtım pompaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8413.40.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Beton pompaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8413.60</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğer döner deplasmanlı (pozitif hareketli) pompalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8422.30.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Şişeleri, kutuları, çuvalları veya diğer kapları doldurmaya,
                                kapamaya, mühürlemeye veya etiketlemeye mahsus makinalar; şişeleri,
                                kavanozları, tüpleri ve benzeri kapları kapsüllemeye mahsus
                                makinalar; içecekleri gazlandırmaya mahsus makinalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8422.40.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğer paketleme veya ambalajlama makinaları (ısı ile büzerek
                                ambalajlamaya mahsus makinalar dahil)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8423.30</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Sabit ağırlıkları tartan basküller ve maddeyi belirli bir ağırlığa
                                göre tartarak çuval ve diğer kaplara doldurmaya mahsus baskül ve
                                teraziler&nbsp;<span style={{ fontWeight: "bold" }}>(34)</span>
                                &nbsp;<span style={{ fontWeight: "bold" }}>(50)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.27</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Forkliftler; kaldırma ve elleçleme tertibatı olan diğer yük
                                arabaları&nbsp;<span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.39</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Lifli selülozik maddelerden kağıt hamuru imaline veya kağıt veya
                                karton imaline veya finisajına mahsus makina ve cihazlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.40</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Cilt makinaları ve kitap formalarını dikmeye mahsus makinalar
                                (münferit yaprakları dikmeye mahsus makinalar dahil)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.41</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Kağıt hamuru, kağıt veya kartonun işlenmesine mahsus diğer makina ve
                                cihazlar (her cins kesme makina ve cihazları dahil)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.42</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Levhaları, silindirleri ve diğer tabedici unsurları hazırlamaya ve
                                yapmaya mahsus makinalar, cihazlar ve teçhizat (84.56 ila&nbsp;
                                84.65 pozisyonlarında yer alan&nbsp; takım tezgahları hariç);
                                levhalar, silindirler ve diğer tabedici unsurlar; matbaacılıkta
                                kullanılmak&nbsp; üzere hazırlanmış levhalar, silindirler ve
                                litoğrafya taşları (örneğin; düz, pütürlü veya cilalı)&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34) (50)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8443.16.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Fleksografik baskı yapan makinalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8444.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Dokumaya elverişli sentetik veya suni maddelerin ekstrüzyonu
                                (basınçlı fışkırtma usulüyle lif imali), çekilmesi, tekstüre
                                edilmesi veya kesilmesine mahsus makina ve cihazlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.45</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Dokumaya elverişli elyafın hazırlanmasına mahsus makinalar; eğirme,
                                katlama veya bükme makinaları veya dokumaya elverişli ipliklerin
                                üretimine mahsus diğer makina ve cihazlar; dokumaya elverişli
                                iplikleri bobinleme veya çilelemeye mahsus (masura sarıcılar dahil)
                                ve 84.46 veya 84.47 pozisyonlarındaki makinalarda kullanılan
                                dokumaya elverişli ipliklerin hazırlanmasına mahsus makinalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.46</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Dokuma makinaları (tezgâhlar)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.47</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Örgü makinaları, dikiş -trikotaj makinaları ve gipe edilmiş iplik,
                                tül, dantela, işleme, şeritci ve kaytancı eşyası veya file imaline
                                mahsus makina ve cihazlar ve püskül, ponpon makina ve
                                cihazları&nbsp;<span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8448.11.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Ratiyerler ve jakardlar; jakard kardlarını azaltıcı, kopya edici,
                                delici veya birleştirici makinalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8448.19</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (84.44,84.45, 84.46 veya 84.47 Pozisyonlarındaki makinalar
                                için yardımcı makina ve cihazlar)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8449.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Şekilli veya parça halinde keçe veya dokunmamış mensucat imalatına
                                veya finisajına mahsus makina ve cihazlar (keçeden şapka imaline
                                mahsus makina ve cihazlar dahil); şapka kalıpları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8452.21.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Otomatik üniteler (Ev tipi olmayan diğer dikiş makinaları)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8452.29.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (Ev tipi ve otomatik üniteli olmayan diğer dikiş
                                makinaları)<span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.53</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Post, deri ve köselelerin hazırlanması, dabaklanması veya işlenmesi,
                                deri veya köseleden yapılan ayakkabı veya diğer eşyanın imaline veya
                                tamirine mahsus makina ve cihazlar (dikiş makinaları hariç)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.54</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalürjide veya metal dökümhanelerinde kullanılan tav ocakları,
                                döküm potaları, külçe kalıpları ve döküm makinaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.56</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Herhangi bir maddenin aşındırılarak, lazerle, diğer ışın veya foton
                                ışınıyla, ultrasonik, elektro-erozyon, elektro-kimyasal, elektron
                                ışını, ionik ışın veya plazma arkı yöntemleri ile işlenmesine mahsus
                                makina ve aletler, su püskürtmeli kesme makinaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.57</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metal işlemeye mahsus işleme merkezleri, tek istasyonlu tezgâhlar ve
                                çok istasyonlu transfer tezgâhları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.58</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metal işlemeye mahsus torna tezgahları ( tornalama merkezleri dahil)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.59</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalleri talaş kaldırmak suretiyle delmeye, raybalamaya,
                                frezelemeye, diş açmaya veya vida yuvası açmaya mahsus takım
                                tezgahları (kızaklı işlem üniteleri dahil) [84.58 pozisyonundaki
                                torna tezgahları (tornalama merkezleri dahil) hariç]
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.60</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalleri veya sermetleri taşlama taşları, aşındırıcılar veya
                                parlatma ürünleri vasıtasıyla işleyen çapak alma, bileme, taşlama,
                                honlama, lepleme, parlatma veya başka şekilde tamamlama işlemlerine
                                mahsus tezgâhlar (84.61 pozisyonundaki dişli açma, dişli taşlama
                                veya dişli tamamlama tezgâhları hariç)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.61</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalleri veya sermetleri talaş kaldırarak işleyen, tarifenin başka
                                bir yerinde belirtilmeyen veya yer almayan planya, vargel, yiv açma,
                                broş, dişli açma, dişli taşlama veya dişli tamamlama tezgâhları,
                                testere, dilme tezgâhları ve diğer takım tezgâhları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.62</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalleri dövme, çekiçleme veya kalıpta dövme suretiyle işlemeye
                                mahsus takım tezgahları (presler dahil); metalleri kavislendirmeye,
                                katlamaya, düzeltmeye, makasla kesmeye, zımbalı kesmeye, taslak
                                çıkartmaya veya şataflamaya mahsus takım tezgahları (presler dahil);
                                metalleri veya metal karbürleri işlemeye mahsus yukarıda sayılmayan
                                presler&nbsp;<span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.63</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Metalleri veya sermetleri talaş kaldırmadan işlemeye mahsus diğer
                                takım tezgâhları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.64</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Taş, seramik, beton, asbestli çimento veya benzeri mineral maddeleri
                                işlemeye veya camı soğuk olarak işlemeye mahsus makinalar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.65</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Ağaç, mantar, kemik, sert kauçuk, sert plastik maddeler veya benzeri
                                sert maddeleri işlemeye mahsus makinalar (çivi çakma, zımbalama,
                                yapıştırma veya başka şekilde birleştirmeye mahsus makinalar dahil)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.77</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Bu fasılın başka pozisyonlarında belirtilmeyen veya yer almayan
                                kauçuk veya plastiğin işlenmesine veya kauçuk veya plastikten
                                eşyanın imaline mahsus makina ve cihazlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8479.10.00.00.19</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (Yol çizme makinaları ile beton serme ve dökme makinaları
                                dışındaki bayındırlık, inşaat ve benzeri işlerde kullanılmaya mahsus
                                makina ve cihazlar)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8479.50.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Sınai robotlar (tarifenin başka yerinde belirtilmeyen veya yer
                                almayan)<span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8479.89</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (Kendine özgü bir fonksiyonu olan diğer makine ve
                                cihazlar)<span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8480.71.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Enjeksiyon veya basınçlı döküm için olanlar (Kauçuk veya plastik
                                maddeler için kalıplar)&nbsp;
                                <span style={{ fontWeight: "bold" }}>(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8480.79.00.00.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (Enjeksiyon veya basınçlı döküm için olmayan kauçuk veya
                                plastik maddeler için kalıplar)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8515.80.10.10.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Ultrasonik kaynak makinaları (Metalleri işlemek için olanlar)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8515.80.90.10.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Ultrasonik kaynak makinaları (Metal dışındaki maddeleri işlemek için
                                olanlar)&nbsp;<span style={{ fontWeight: "bold" }}>(34)</span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                <span style={{ fontWeight: "bold" }}>8515.80.90.90.00</span>
                            </p>
                        </td>
                        <td>
                            <p>
                                Diğerleri (Metal dışındaki maddeleri işlemeye mahsus ultrasonik
                                olmayan kaynak makinaları)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(34)</span>
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    gümrük tarife istatistik pozisyonlarında yer alan ve amortismana tabi
                    iktisadi kıymet niteliği taşıyan makine ve cihazların&nbsp; (kullanılmış
                    olanları ile aksam, parça, aksesuar ve teferruatları hariç) finansal
                    kiralamaya konu olmak üzere, 3226 sayılı Finansal Kiralama Kanununa göre
                    finansal kiralama şirketlerine teslimi ve bu malların finansal kiralama
                    şirketleri tarafından katma değer vergisi mükellefleri ile işlemleri katma
                    değer vergisinden istisna edildiği için katma değer vergisi mükellefiyeti
                    bulunmayan ancak kazançları bilanço esasına göre tespit edilen gelir ve
                    kurumlar vergisi mükelleflerine kiralanması ve teslimi,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>18-</span>&nbsp;Kur'an-ı Kerim (Kur'an
                    meal ve tefsir kitapları ile münhasıran Kur'an cüz, sûre, ayet ve/veya
                    meallerini içeren kitaplar dâhil) ile Tevrat, Zebur ve İncil
                    kitapları.&nbsp;<span style={{ fontWeight: "bold" }}>(27)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>19-</span>&nbsp;<em>(96)</em>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>20-</span>&nbsp;İl özel idareleri,
                    belediyeler ile bağlı kuruluşları ve bunların üyesi olduğu mahalli idare
                    birliklerine, doğrudan doğruya veya dolaylı olarak, birlikte ya da ayrı ayrı
                    sermayesinin yarısından fazlası bunlara ait şirketler tarafından doğrudan
                    sunulan 4/1/2002 tarihli ve 4734 sayılı Kamu İhale Kanununun 62 nci
                    maddesinin birinci fıkrasının (e) bendinde belirtilen personel
                    çalıştırılmasına dayalı hizmetler.&nbsp;
                    <span style={{ fontWeight: "bold" }}>(41) (42) (55)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>21-&nbsp;</span>"Yenilenmiş Ürünlerin
                    Satışı Hakkında Yönetmelik"
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>kapsamında en az bir yıl
                    öncesine ilişkin data, ses ya da kısa mesaj kullanım trafiği bulunan
                    kullanılmış cep telefonlarının yenilenmek ve sertifikalandırılmak kaydıyla
                    yenileme merkezleri ve yetkili satıcılar tarafından yenilenmiş ürün
                    garantisi verilerek teslimleri (Mükeleflerin, indirimli orana tabi
                    işlemlerine ait iade hesabına, bu sıra kapsamında teslim ettikleri mallar
                    nedeniyle yüklendikleri vergiler dahil edilmez.)&nbsp;
                    <span style={{ fontWeight: "bold" }}>(79)</span>
                </p>
                <p align="center">
                    <span style={{ fontWeight: "bold" }}>(II) SAYILI LİSTE</span>
                </p>
                <p align="center" style={{ textAlign: "left" }}>
                    <span style={{ fontWeight: "bold" }}>(91)</span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <span style={{ fontWeight: "bold" }}>1-</span>&nbsp;Kütlü ve elyaf pamuk,
                    linter pamuk, pamuk lifi döküntüleri, natürel veya tops haldeki tiftik, yün
                    ve yapağı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>2-</span>&nbsp;Türk Gümrük Tarife
                    Cetvelinin 41.01 pozisyonundaki sığır ve atların, 41.02 pozisyonundaki koyun
                    ve kuzuların (astragan veya karakul, persaniye, breitschwanz ve benzerleri,
                    Hint, Çin, Moğolistan ve Tibet kuzuları hariç), 41.03 pozisyonundaki keçi ve
                    oğlakların (Yemen, Moğolistan ve Tibet keçi ve oğlakları hariç) ham post ve
                    derileri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>3-</span>&nbsp;İplikler ve iplik imali
                    için hazırlanan her nevi filamentler, lifler, vb. (Pamuktan, yünden,
                    tiftikten, hayvan kıllarından, ipekten, sentetikten, suni maddelerden,
                    dokumaya elverişli her nevi maddelerden veya bunların karışımlarından elde
                    edilenler.),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>4-</span>&nbsp;Pamuklu, yünlü, ipekli,
                    sentetik, suni veya bunların karışımlarından örme dahil her nevi mensucat
                    (pamuk, keten, ipek, sentetik, suni, kauçuk iplik, lif ve benzerleriyle,
                    hayvan kıllarıyla, dokumaya elverişli maddelerle veya bunların karışımları
                    ile birlikte; el tezgahlarında veya diğer şekillerde dokunsun dokunmasın,
                    ağartılmış, boyanmış, baskılı vb. şekillerde olsun olmasın), emdirilmiş,
                    sıvanmış, kaplanmış veya lamine edilmiş dokumaya elverişli mensucat,
                    dokunmamış mensucat, vatka, keçe ile her nevi dantela, kordela, kordon ve
                    işlemeler,
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      5- (2016/9542 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      25/11/2016)&nbsp;
    </span>
                    Yukarıdaki 4 numaralı sırada yazılı mensucat, vatka, keçe ve dantela,
                    kordela, kordon ve işlemelerden mamul; iç ve dış giyim eşyası (şapka,
                    kravat, kaşkol, şal, eşarp, kemer, çorap, eldiven vb. dahil), omuz vatkası,
                    astar, apolet, ilikleme tertibatı, cep, kol, yaka, rozet ve fırfır ile
                    bunların benzerleri, havlu, bornoz, perde (montaj ve hareket ettirici
                    mekanizması kısmen alüminyum, plastik ve benzeri malzeme içerenler
                    dahil)&nbsp;<span style={{ fontWeight: "bold" }}>(66)</span>, çarşaf,
                    yastık, yorgan, battaniye, uyku tulumu, her türlü kılıf ve örtüler ile
                    bunların benzeri ev tekstil ürünleri (taşıtlarda kullanılanlar dahil)
                    (yataklar hariç) ile kıymetli taş ve madenler hariç her nevi maddeden mamul
                    fermuar, çıtçıt, düğme, kopça, boncuk ve benzerleri,
                    <span style={{ fontWeight: "bold" }}>&nbsp;(46)</span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      6- a) (2008/13902 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      20/07/2008)
    </span>
                    &nbsp; İşlenmiş post, deri ve köseleler ile bunların taklitleri ve bunlardan
                    mamul giyim eşyası (şapka, kemer, kravat, eldiven ve benzerleri dahil),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;18/12/2007 tarihli ve
                    2007/13007 sayılı Kararnamenin eki İstatistik Pozisyonlarına Bölünmüş Türk
                    Gümrük Tarife Cetvelinin "4302.19.95.00.19 Diğerleri" pozisyonunda yer alan
                    eşyalardan yalnız sığırların (bufalo dahil) dabaklanmış ve aprelenmiş
                    kürkleri,<span style={{ fontWeight: "bold" }}>&nbsp;(6)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(52)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>7-</span>&nbsp;Her nevi maddeden mamul
                    ayakkabı, terlik, çizme ve benzerleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>8-</span>&nbsp;Her nevi maddeden mamul
                    çanta, bavul, valiz ve benzerleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>9-</span>&nbsp;Halılar ve diğer
                    dokumaya elverişli maddelerden yer kaplamaları,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>10-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2016/9542 sayılı Kararname ile değiştirilen sıra. Yürürlük: 25/11/2016)
    </span>
                    &nbsp;Fason olarak yapılan tekstil, konfeksiyon, deri ve saya işleri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(47)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>11-</span>&nbsp;3100 sayılı Katma Değer
                    Vergisi Mükelleflerinin Ödeme Kaydedici Cihazları Kullanmaları Mecburiyeti
                    Hakkında Kanun kapsamına giren ödeme kaydedici cihaz teslimleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>12-</span>&nbsp;13/10/1983 tarihli ve
                    2918 sayılı Karayolları Trafik Kanunu ile Karayolları Trafik Yönetmeliğinin
                    64 üncü maddesine göre otobüs, kamyon ve çekici türü taşıtlarda
                    bulundurulması ve kullanılması zorunlu olan takoğraf cihazı teslimleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>13-</span>&nbsp;Türk Gümrük Tarife
                    Cetvelinin 4801.00 pozisyonunda yer alan gazete kağıdı (rulo veya tabaka
                    halinde) ile 48.02 pozisyonunda yer alan baskı ve yazı kağıtlarının teslimi,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>14-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (18/12/2018 tarihli ve 475 sayılı Cumhurbaşkanı Kararının 2 nci maddesiyle
      değiştirilen sıra. Yürürlük: 1/1/2019)
    </span>
                    &nbsp;Kitap ve benzeri yayınlar (Elektronik kitap (e-kitap) ve benzeri
                    yayınların elektronik ortamda satışı, elektronik kitap okuyucu, tablet ve
                    benzerlerinin teslimi ile 21/6/1927 tarihli ve 1117 sayılı Kanun hükümlerine
                    göre poşetlenerek satılanların tesliminde, bu Kararın 1 inci maddesinin
                    birinci fıkrasının (a) bendinde belirtilen vergi oranı uygulanır.), kurşun
                    kalem, boya kalemleri, sulu boya ve pastel boyalar, okul defterleri, silgi,
                    kalemtıraş, cetvel, pergel, gönye, iletki,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(61)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>15-</span>&nbsp;Üniversite ve
                    yüksekokullar ile 5580 sayılı Özel Öğretim Kurumları Kanunu, 2828 sayılı
                    Sosyal Hizmetler ve Çocuk Esirgeme Kurumu Kanunu ve 573 sayılı Özel Eğitim
                    Hakkında Kanun Hükmünde Kararname kapsamında verilen eğitim ve öğretim
                    hizmetleri, "Okul Servis Araçları Hizmet Yönetmeliği" kapsamında verilen
                    öğrenci taşıma servis hizmetleri ile "Özel Öğrenci Yurtları Yönetmeliği"
                    hükümlerine tabi yurtlarda verilen hizmetler,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>16-</span>&nbsp;Sinema, tiyatro, opera,
                    operet, bale, müze giriş ücretleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>17-</span>&nbsp;İnsan gıdası olarak
                    kullanılan mamalar, insan ve hayvan sağlığı için kullanılan antiserumlar,
                    immunglobulinler, kan ve kan kompenentleri ile kan ürünleri, aşılar,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>18-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>(14</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      /11/2024 tarihli ve 9126 sayılı Cumhurbaşkanı Kararı 1.maddesi ile
      değiştirilen sıra
    </span>
                    <span style={{ fontWeight: "bold" }}>;</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 15/11/2024
    </span>
                    <span style={{ fontWeight: "bold" }}>)&nbsp;</span>Sağlık Bakanlığı
                    tarafından ruhsatlandırılan veya ithaline izin verilen özel tıbbi amaçlı
                    gıdalar ve beşeri tıbbi ürünler ile beşeri tıbbi ürünlerin terkibinde
                    bulunan etkin maddeler ve etkin madde üretiminde kullanılan hammaddeler (Bu
                    sıradaki malların (I) sayılı listede de yer alması halinde, (II) sayılı
                    listede belirlenen oran uygulanır.),&nbsp;
                    <span style={{ fontWeight: "bold" }}>(105)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>19-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2012/2931 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      25/03/2012)&nbsp;
    </span>
                    18/12/2007&nbsp;tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 0106.90.00.90.14&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (52) </span> &nbsp;pozisyonunda yer
                    alan biyolojik mücadelede kullanılan parazit ve predatörler&nbsp;ile&nbsp;
                    <span style={{ fontWeight: "bold" }}>(24)</span>&nbsp;Gıda, Tarım ve
                    Hayvancılık Bakanlığı tarafından zirai mücadelede kullanılmak üzere
                    ruhsatlandırılan bitki koruma ürünleri&nbsp;
                    <span style={{ fontWeight: "bold" }}>(23)</span>&nbsp;bu ürünlerin
                    terkibinde bulunan aktif maddeler ve aktif madde üretiminde kullanılan
                    hammaddeler,&nbsp;<span style={{ fontWeight: "bold" }}>(25)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>20-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2012/2931 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      25/03/2012)&nbsp;
    </span>
                    Gıda, Tarım ve Hayvancılık Bakanlığı tarafından ruhsatlandırılan veteriner
                    ispençiyari ve tıbbi müstahzarlar (veteriner kozmetikleri hariç), bu
                    ürünlerin terkibinde bulunan etkin maddeler ve bu etkin maddelerin
                    üretiminde kullanılan hammaddeler,&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (26) </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>21-</span>&nbsp;İlgili Bakanlıklar ya
                    da kanunlarla izin verilen gerçek veya tüzel kişiler tarafından yerine
                    getirilen insan veya hayvan sağlığına yönelik koruyucu hekimlik, teşhis,
                    tedavi ve rehabilitasyon hizmetleri (hayvan ırkının ıslahına yönelik
                    hizmetler dahil)<span style={{ fontWeight: "bold" }}>&nbsp;(48)</span>
                    &nbsp;ile bu hizmetleri ifa edenlere hekimlerce veya hekimler vasıtasıyla
                    verilen hizmetler, ambulans hizmetleri,&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>22-</span>&nbsp;
                    <strong>
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 6.maddesi ile
        değiştirilen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>{" "}
                    Sağlık Bakanlığı tarafından yayımlanan "Tıbbi Cihaz Yönetmeliği" ve "İn
                    Vitro Tanı Amaçlı Tıbbi Cihaz Yönetmeliği" hükümlerine tabi olan cihazların
                    teslimi ile bunların kiralanması hizmetleri,{" "}
                    <strong>
                        (97) &nbsp;<span style={{ fontWeight: "bold" }}>(</span>
                    </strong>
                    <span style={{ fontWeight: "bold" }}>14</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      /11/2024 tarihli ve 9126 sayılı Cumhurbaşkanı Kararı 2.maddesi ile&nbsp;
    </span>
                    <strong>
      <span style={{ fontWeight: "bold" }}>
        &nbsp;eklenen ibare. Yürürlük: 15/11/2024)
      </span>
                    </strong>{" "}
                    (Özel tüketim vergisine tabi olan mallar ile 30/12/2023 tarihli ve 8040
                    sayılı Cumhurbaşkanı Kararı eki İstatistik Pozisyonlarına Bölünmüş Türk
                    Gümrük Tarife Cetvelinin 85.17 pozisyonunda yer alan mallar hariç)
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>23-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2015/8353 sayılı Kararname ile yürürlükten kaldırılan sıra. Yürürlük:
      01.01.2016) (9) (39)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>24-</span>&nbsp;Gazino, açık hava
                    gazinosu, bar, dans salonu, diskotek, pavyon, taverna, birahane, kokteyl
                    salonu ve benzeri yerler hariç olmak üzere kahvehane, kır kahvesi, çay
                    bahçesi, çay ocağı, kıraathane, kafeterya, pastane, ayakta yemek yenilen
                    yerler, yemeği pakette satan veya diğer şekillerde yemek hizmeti sunan
                    yerler, lokanta, içkili lokanta, kebapçı ve benzeri yerlerde{" "}
                    <strong>
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 7.maddesi ile
        kaldırılan ibare
      </span>
                        ;
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>
                    <strong> (98)</strong>&nbsp;verilen hizmetler (bu yerlerde verilen
                    hizmetlerin alkollü içeceklere isabet eden kısmı hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>25-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2008/13234 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      09/02/2008)&nbsp;
    </span>
                    Otel, motel, pansiyon, tatil köyü ve benzeri konaklama tesislerinde sunulan
                    geceleme hizmeti (1618 sayılı Kanun hükümlerine göre Kültür ve Turizm
                    Bakanlığından işletme belgesi almış seyahat acenteleri tarafından müşteriye
                    aktarılan geceleme hizmet tutarı ve bu hizmete ilişkin aracılık bedellerine
                    de konaklama tesislerinde verilen geceleme hizmetlerinin ait olduğu oran
                    uygulanır. Konaklama tesislerinde geceleme hizmetinden yararlanmayanlara
                    verilen tüm hizmetler ile geceleme hizmetiyle beraber verilen ancak ayrıca
                    belgelendirilen ya da geceleme hizmetine ait belgede ayrıca fiyatlandırılan
                    hizmetler bu sıra kapsamında yer almamaktadır. Ancak geceleme hizmeti
                    kapsamında verilmesi ve geceleme bedeline dahil edilmesi mutat olan diğer
                    hizmetler bu sıra kapsamında yer almakla birlikte bu şekilde belirlenen
                    geceleme bedeli içinde sunulan alkollü içeceklere ilişkin yüklenilen katma
                    değer vergisi tutarları, hizmeti sunanlar tarafından indirim konusu
                    yapılamaz.)&nbsp;<span style={{ fontWeight: "bold" }}>(1)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>26-</span>&nbsp;Yaşlı, sakat ve
                    düşkünler için bakım ve huzurevleri ile yetimhanelerde verilen hizmetler,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>27-</span>&nbsp;Belediyeler ve bunların
                    iktisadi işletmeleri tarafından verilen atık su hizmetleri.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>28-</span>&nbsp;18/12/2007 tarihli ve
                    2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına&nbsp;&nbsp;Bölünmüş Türk Gümrük Tarife Cetvelinin;&nbsp;
                    <span style={{ fontWeight: "bold" }}>(2)</span>
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8424.81 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tarıma ve bahçeciliğe ait olanlar (sıvı veya toz halindeki maddeleri
                                püskürtmeye, dağıtmaya veya pülverize etmeye mahsus mekanik
                                cihazlar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8428.20.30.90.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğerleri (Tarımda kullanılmak üzere özel olarak imal edilmiş
                                pnömatik elevatörler ve konveyörler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8428 90.71 00 00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Zirai traktörlere takılmak üzere imal edilenler (Tarımda kullanılmak
                                üzere özel olarak imal edilmiş yükleyiciler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8428.90.95.90.11</span>&nbsp;
                                <b>(52)</b>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Zirai traktörler için hidrolik kaldırıcılar&nbsp;<b>(52)</b>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8432.10 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Pulluklar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8432.21.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diskli tırmıklar (diskorolar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8432 29</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğerleri: (Tırmıklar, skaritikatörler, kültivatörler, zararlı
                                otları ayıklayan makinalar, çapa makinaları)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8432.30 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Ekim ve dikim makinaları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8432.40 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Gübreleme makina ve cihazları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.20</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Çayır&nbsp;<span style={{ fontWeight: "bold" }}>(52)</span>
                                &nbsp;biçme makinaları (traktörlere monte edilen parmaklı biçme
                                makinaları dahil)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.30 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Ot hazırlama makina ve cihazları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.40 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Ot ve saman balyalama makina ve cihazları (ot ve samanları toplayıp
                                demet veya balya yapmaya mahsus olanlar dahil)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.51.00.00.00</span>&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Biçer döverler</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.52</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğer harman makina ve cihazları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.53</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Kök ve yumru sökme&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>&nbsp;makinaları
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.11.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Kendinden hareketli olanlar (silaj makinası)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.19.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri (silaj makinası)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.30.00.11 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Orak makinaları (biçerler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.30.00.12 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Biçer toplarlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.30.00.13 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Biçer bağlarlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.80.00.11 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Pamuk hasat makinası&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.80.00.12 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Mısır hasat makinası&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.80.00.13 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Mısır toplama ve daneleme makinaları&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.59.80.00.19 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğerleri (diğer hasat ve harman makina ve cihazları)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8433.90</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Aksam ve parçalar (84.33 pozisyonundaki makina ve cihazlara ait
                                olanlar)<span style={{ fontWeight: "bold" }}>&nbsp;(11)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>84.34</span>{" "}
                                <strong>(99)</strong>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Süt sağma makinaları ve sütçülükte kullanılan makina ve cihazlar{" "}
                                <strong>(99)</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8436.10.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Hayvan yemlerini hazırlamaya mahsus makina ve cihazlar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8436.80.91.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Otomatik yalaklar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8436.80.99.00.11 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Arıcılığa mahsus bal mumunu petek yapan makina ve cihazlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8436.80.99.00.12 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Arıcılığa mahsus diğer makina ve cihazlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8436.80.99.00.13 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Mekanik hayvan kırkma makinaları (elle çalışanlar hariç)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8510.20.00.00.12</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Hayvan kırkma makinaları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.10.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motokültörler&nbsp;<span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.11.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 18 kW.ı geçmeyenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.20.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 18 kW.ı geçen fakat 37 kW.ı geçmeyenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.25.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 37 kW.ı geçen fakat 59 kW.ı geçmeyenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.31.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 59 kW.ı geçen fakat 75 kW.ı geçmeyenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.35.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 75 kW.ı geçen fakat 90 kW.ı geçmeyenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8701.90.39.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Motor gücü 90 kW.ı geçenler (traktörler)
                                <span style={{ fontWeight: "bold" }}>&nbsp;(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8716.20.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tarımda kullanılmaya mahsus kendinden yüklemeli veya boşaltmalı
                                römork ve yarı römorklar
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    <strong>(100)</strong> 30/12/2021 tarihli ve 5045 sayılı Cumhurbaşkanı
                    Kararı eki İstatistik Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin
                </p>
                <table border={1} style={{ width: 642 }}>
                    <tbody>
                    <tr>
                        <td width={158}>
                            <strong>8418.69.00.99.19 </strong>
                        </td>
                        <td width={474}>Diğerleri (Yalnız süt soğutma tankları)</td>
                    </tr>
                    <tr>
                        <td>
                            <strong>8433.60.00.00.00</strong>
                        </td>
                        <td>
                            Yumurtaları, meyvaları veya diğer tarım ürünlerini ağırlık veya
                            büyüklüklerine göre ayırmaya veya temizlemeye mahsus makina ve
                            cihazlar
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>gümrük tarife istatistik pozisyon numaralarında yer alan mallar.</p>
                <p>
                    <span style={{ fontWeight: "bold" }}>29-</span>&nbsp;&nbsp;18/12/2007
                    tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik Pozisyonlarına
                    Bölünmüş Türk Gümrük Tarife Cetvelinin;&nbsp;
                    <span style={{ fontWeight: "bold" }}>(3)</span>
                </p>
                <div align="center">
                    <table cellSpacing={0} cellPadding={0} border={0}>
                        <tbody>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.29.52.10.00.00</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>Paletli ekskavatörler (kulesi 360 derece dönebilen)</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.29.52.90.00.11</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>
                                    Lastik tekerlekli olanlar (kulesi 360 derece dönebilen makina ve
                                    cihazlar)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.29.59.00.10.11</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>Beko loder</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.47</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>
                                    Örgü makinaları, dikiş-trikotaj makinaları ve gipe edilmiş iplik,
                                    tül, dantela, işleme, şeritçi ve kaytancı eşyası veya file imaline
                                    mahsus makina ve cihazlar ve püskül, ponpon makina ve cihazları
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.52.10</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>Ev tipi dikiş makinaları</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.52.21.00.00.00</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>Otomatik üniteler (diğer dikiş makinaları)</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.52.29.00.00.00</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>Diğerleri (diğer dikiş makinaları)</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.58</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>
                                    Metal işlemeye mahsus torna tezgahları (tornalama merkezleri
                                    dahil)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={120} valign="top">
                                <p>
                                    <span style={{ fontWeight: "bold" }}>84.59</span>
                                </p>
                            </td>
                            <td width={472} valign="top">
                                <p>
                                    Metalleri talaş kaldırmak suretiyle delmeye, raybalamaya,
                                    frezelemeye, diş açmaya veya vida yuvası açmaya mahsus takım
                                    tezgahları (kızaklı işlem üniteleri dahil) [84.58 pozisyonundaki
                                    torna tezgahları (tornalama merkezleri dahil) hariç]
                                </p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p>&nbsp;</p>
                <p>gümrük tarife istatistik pozisyon numaralarında yer alan mallar,</p>
                <p>
                    <span style={{ fontWeight: "bold" }}>30-</span>&nbsp;8/6/1994 tarihli ve
                    3996 sayılı Bazı Yatırım ve Hizmetlerin Yap-İşlet-Devret Modeli Çerçevesinde
                    Yaptırılması Hakkında Kanuna göre yap-işlet-devret modeli çerçevesinde
                    yaptırılan köprülerin ve denizaltı karayolu tünellerin&nbsp;
                    <span style={{ fontWeight: "bold" }}>(54)</span>&nbsp;geçiş ücretleri&nbsp;
                    <span style={{ fontWeight: "bold" }}>(44)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>31-&nbsp;</span>Türk Gümrük Tarife
                    Cetvelinin 2711.19.00.00.11 gümrük tarife istatistik pozisyon numarasında
                    yer alan Sıvılaştırılmış Petrol Gazı (L.P.G.)' nın, motorlu taşıtlarda yakıt
                    olarak kullanılacak olanları (otogaz) hariç olmak üzere Enerji Piyasası
                    Düzenleme Kurumundan "LPG Dağıtıcı Lisansı"nı haiz olanlarca teslimi ile
                    bunlardan satın alanların sonraki safhalardaki teslimi,&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (53) </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>32-</span>&nbsp;6100 sayılı Hukuk
                    Muhakemeleri Kanunu ve 1136 sayılı Avukatlık Kanununda yer alan adli yardım
                    ve adli müzaharet hükümleri kapsamında verilen avukatlık hizmetleri
                    ile&nbsp;<span style={{ fontWeight: "bold" }}>(80)</span>&nbsp;aile
                    mahkemeleri, tüketici mahkemeleri ve çocuk mahkemelerinin görev alanına
                    giren davalar ve işler, vesayet davaları ve işleri; bu davalara bağlı kanun
                    yolları; iş uyuşmazlıklarında dava şartı olarak arabuluculuk ile bunlara
                    bağlı ilamlı icra takipleri kapsamında verilen avukatlık hizmetleri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(67)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>33</span>-&nbsp;
                    <span style={{ fontWeight: "bold" }} />
                    30/12/2019 tarihli ve 1951 sayılı Cumhurbaşkanı Kararı eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin;
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.30</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>
                                Yüksekliği ayarlanabilen oturmaya mahsus döner koltuk ve sandalyeler
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.40.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>
                                Yatak haline getirilebilen oturmaya mahsus mobilyalar (kamp veya
                                bahçede kullanılanlar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.52.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Bambudan</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.53.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Hintkamışından</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.59.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>
                                Diğerleri (Kamış, sepetçi söğüdü, bambu veya benzeri maddelerden
                                oturmaya mahsus mobilyalar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.61</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>İçleri doldurulmuş, kaplanmış olanlar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.69</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğerleri (Ahşap iskeletli oturmaya mahsus diğer mobilyalar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.71</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>
                                İçleri doldurulmuş, kaplanmış olanlar (Metal iskeletli oturmaya
                                mahsus diğer mobilyalar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.79</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğerleri (Metal iskeletli oturmaya mahsus diğer mobilyalar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9401.80</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Oturmaya mahsus diğer mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9402.10.00.00.19</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğerleri (Berber koltukları veya benzeri koltuklar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.10</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Bürolarda kullanılan türden metal mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.20</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Metalden diğer mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.30</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Bürolarda kullanılan türden ahşap mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.40</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Mutfaklarda kullanılan türden ahşap mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.50</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Yatak odalarında kullanılan türden ahşap mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.60</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğer ahşap mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.70</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Plastik maddelerden mobilyalar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.82.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Bambudan olanlar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.83.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Hintkamışından</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9403.89.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğerleri (Diğer maddelerden mobilyalar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9404.10.00.00.00</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Şilte mesnetleri</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9404.21</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>
                                Gözenekli kauçuktan veya plastik maddelerden olanlar (kaplanmış
                                olsun olmasın) (Şilteler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={119} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9404.29</span>
                            </p>
                        </td>
                        <td valign="top" style={{ width: 472 }}>
                            <p>Diğer maddelerden olanlar (Şilteler)</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    gümrük tarife istatistik pozisyon numaralarında yer alan mallar,"&nbsp;
                    <span style={{ fontWeight: "bold" }}>(70)</span>
                </p>
                <p>
                    <strong>34-</strong>&nbsp;{" "}
                    <strong>
                        (5249 sayılı Cumhurbaşkanı Kararıyla eklenen sıra; Yürürlük: yayımlandığı
                        tarihten itibaren tahakkuk ettirilen bedellere uygulanmak üzere
                        01.03.2022)
                    </strong>{" "}
                    Mesken ve tarımsal sulama abone gruplarına yapılan elektrik teslimleri
                </p>
                <p>
                    <strong>35-</strong>{" "}
                    <strong>
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 9.maddesi ile
        eklenen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022){" "}
      </span>
                    </strong>
                    Konutların net alanının 150 m2'ye kadar olan kısmı,
                </p>
                <p>
                    <strong>
                        36- (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 9.maddesi ile
        eklenen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022){" "}
      </span>
                    </strong>
                    Arsa ve arazi teslimleri,
                </p>
                <p>
                    <strong>37-</strong>{" "}
                    <span style={{ fontWeight: "bold" }}>
      (7346 sayılı Cumhurbaşkanı Kararı ile değişen sıra. Yürürlük: 10/07/2023)
    </span>{" "}
                    Diş fırçası ve macunu, diş iplikleri, <strong>(104)</strong>
                </p>
                <p>
                    <strong>38-</strong>{" "}
                    <strong>
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 9.maddesi ile
        eklenen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022){" "}
      </span>
                    </strong>
                    30/12/2021 tarihli ve 5045 sayılı Cumhurbaşkanı Kararı eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 9619.00 pozisyonunda
                    yer alan mallar,
                </p>
                <p>&nbsp;</p>
                <p />
                <p>
                    <span style={{ fontWeight: "bold" }}>DİPNOTLAR:</span>
                </p>
                <p>
                    (*) (2007/13033 sayılı KDV oranlarına ilişkin Genel Kararnamede 2008/13234,
                    2008/13426, 2008/13902, 2008/14092, 2009/14812, 2009/15200, 2011/1673,
                    2011/2466, 2011/2604, 2012/2697, 2012/2931, 2012/3594, 2012/4116, 2013/4345,
                    2013/5595, 2015/7205, 2015/8353, 2016/8705, 2016/8998, 2016/9153, 2016/9542,
                    2017/9759, 2017/10468, 2018/11333, 2018/11658, 2018/11674 ve 2018/11750
                    sayılı kararnameler ile 22, 287, 475, 535, 843, 845, 1013 ve 1594 sayılı
                    Cumhurbaşkanı kararlarıyla yapılan ek ve değişiklikler işlenmiştir.)
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(1)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2008/13234 sayılı Kararname ile değiştirilmeden önceki hali)
      25-&nbsp;
    </span>
                    Otel, motel, pansiyon, tatil köyü ve benzeri konaklama tesislerinde sunulan
                    geceleme hizmeti (Konaklama tesislerinde geceleme hizmetinden
                    yararlanmayanlara verilen tüm hizmetler ile geceleme hizmetiyle beraber
                    verilen ancak ayrıca belgelendirilen ya da geceleme hizmetine ait belgede
                    ayrıca fiyatlandırılan hizmetler bu sıra kapsamında yer almamaktadır. Ancak
                    geceleme hizmeti kapsamında verilmesi ve geceleme bedeline dahil edilmesi
                    mutat olan diğer hizmetler bu sıra kapsamında yer almakla birlikte bu
                    şekilde belirlenen geceleme bedeli içinde sunulan alkollü içeceklere ilişkin
                    yüklenilen katma değer vergisi tutarları, hizmeti sunanlar tarafından
                    indirim konusu yapılamaz.)&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(2)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2008/13234 sayılı BKK ile eklenen sıra. Yürürlük: 09/02/2008)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(3)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2008/13426 sayılı BKK ile eklenen sıra. Yürürlük: 07/04/2008)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(5)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2008/13902 sayılı BKK ile eklenen sıra. Yürürlük: 01/08/2008)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(6)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2008/13902 sayılı BKK ile değişmeden önceki şekli)
    </span>
                    &nbsp;"6-İşlenmiş post, deri ve köseleler ile bunların taklitleri ve
                    bunlardan mamul giyim eşyası (şapka, kemer, kravat, eldiven ve benzerleri
                    dahil),"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(9)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2008/14092 sayılı BKK ile eklenen ibare. Yürürlük: 21/09/2008)
    </span>
                    &nbsp;"(18/12/2007 tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 2303.10 pozisyonunda
                    yer alan nişastacılık artıkları ve benzeri artıklar ile 2303.30.00.00.00
                    pozisyonunda yer alan biracılık ve damıtık içki sanayiinin posa ve artıkları
                    hariç)"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(10)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2009/14812 sayılı BKK ile eklenen ibare. Yürürlük: 30/03/2009)
    </span>
                    &nbsp;"8701.90.50.00.00 Kullanılmış olanlar ile"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(11)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2009/14812 sayılı BKK ile eklenen satır. Yürürlük: 30/03/2009)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(13)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2011/1673 sayılı BKK ile değişmeden önceki şekli)&nbsp;
    </span>
                    6- 24/6/1995 tarihli ve 552 sayılı Kanun Hükmünde Kararnameye göre toptancı
                    hallerinde faaliyette bulunanlara ve bunlar tarafından gerçek usule tabi
                    katma değer vergisi mükelleflerine yapılan taze sebze ve meyve (mamulleri
                    hariç) teslimleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(14)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2011/2466 sayılı BKK ile eklenen ibare. Yürürlük: 28/11/2011)&nbsp;
    </span>
                    bulgur,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(15)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2011/2466 sayılı BKK ile eklenen ibare. Yürürlük: 28/11/2011)&nbsp;
    </span>
                    "20/12/2010 tarihli ve 2010/1180 sayılı Bakanlar Kurulu Kararı ile yürürlüğe
                    konulan İstatistik Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin
                    01.05 pozisyonunda yer alan hayvanlar ile 2 no.lu faslında yer alan mallar,"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(16)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2011/2466 sayılı Kararname ile kaldırılmadan önceki ibare)
    </span>
                    &nbsp;,01.05
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(17)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2011/2466 sayılı Kararname ile kaldırılmadan önceki bend)
    </span>
                    &nbsp;2 no.lu faslında yer alan mallar,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(18)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2011/2604 sayılı Kararname ile eklenen sıra. Yürürlük:
      27/12/2011)&nbsp;&nbsp;
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(19)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2011/2604 sayılı Kararname ile eklenen sıra. Yürürlük:
      27/12/2011)&nbsp;&nbsp;
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(20)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2011/2604 sayılı Kararname ile değişmeden önceki şekli)&nbsp;
    </span>
                    Finansal kiralama işlemlerinde, işleme konu olan malın tabi olduğu katma
                    değer vergisi oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(21)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2012/2697 sayılı Kararname ile eklenen geçici madde Yürürlük: 28/01/2012)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(22)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2012/2931 sayılı Kararname ile değişmeden önceki şekli)
    </span>
                    &nbsp;18- Sağlık Bakanlığı tarafından ruhsatlandırılan veya ithaline izin
                    verilen beşeri tıbbi ürünler,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(23)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2008/13902 sayılı BKK ile değişmeden önceki şekli)&nbsp;
    </span>
                    "19- Tarım ve Köyişleri Bakanlığı tarafından zirai mücadelede kullanılmak
                    üzere ruhsatlandırılan bitki koruma ürünleri,"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(24)</span>19-&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2008/13902 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      20/07/2008)&nbsp;
    </span>
                    18/12/2007 tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 0106.90.00.90.14
                    pozisyonunda yer alan biyolojik mücadelede kullanılan parazit ve predatörler
                    ile Tarım ve Köyişleri Bakanlığı tarafından zirai mücadelede kullanılmak
                    üzere ruhsatlandırılan bitki koruma ürünleri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(23)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(25)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>2012/2931 sayılı Kararname ile</span>
                    &nbsp;Tarım ve Köyişleri Bakanlığının adı "Gıda, Tarım ve Hayvancılık
                    Bakanlığı olarak değiştirilmiş" ve "bu ürünlerin terkibinde bulunan aktif
                    maddeler ve aktif madde üretiminde kullanılan hammaddeler" ibaresini
                    içerecek şekilde 19 uncu sıra değiştirilmiştir.&nbsp;
                    <span style={{ fontWeight: "bold" }}>(24)</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(26)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2012/2931 sayılı Kararname ile değişmeden önceki şekli)
    </span>
                    &nbsp;20- Tarım ve Köyişleri Bakanlığı tarafından ruhsatlandırılan veteriner
                    ispençiyari ve tıbbi müstahzarlar (veteriner kozmetikleri hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(27)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2012/3594 sayılı Kararname ile eklenen sıra. Yürürlük: 13/09/2012)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(29)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2013/4345 sayılı BKK ile eklenen ibare. Yürürlük: 25/02/2013)
    </span>
                    &nbsp;"(02.07 pozisyonu ve 0209.90.00.00.00 gümrük tarife istatistik
                    pozisyon numarasında yer alan mallar hariç)"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(30)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2013/4345 sayılı Kararname ile değişmeden önceki bend)&nbsp;
    </span>
                    b)&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (2011/2466 sayılı BKK ile kaldırılan bend. Yürürlük: 28/11/2011){" "}
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(31)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2013/5595 sayılı BKK ile kaldırılan ibare)
    </span>
                    &nbsp;01.05 pozisyonunda yer alan hayvanlar ile
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(32)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2013/5595 sayılı BKK ile eklenen ibare. Yürürlük: 02/12/2013)&nbsp;
    </span>
                    "bu yayınların elektronik ortamda satışı (elektronik gazete ve dergi
                    okuyucu, tablet ve benzerleri hariç),"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(33)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      2013/5595 sayılı BKK ile değişen satırlar
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(34)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      2013/5595 sayılı BKK ile eklenen satırlar
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(35)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>2013/5595 sayılı BKK ile&nbsp;</span>
                    "01.04" ibaresi, "01.04, 01.05" şeklinde değiştirilmiştir. (Yürürlük:
                    02/12/2013)
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(36)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2013/5595 sayılı BKK ile eklenen ibare. Yürürlük: 02/12/2013)&nbsp;
    </span>
                    elektronik kitap (e-kitap) ve benzeri yayınların elektronik ortamda satışı
                    (elektronik kitap okuyucu, tablet ve benzerleri hariç),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(37)</span>&nbsp;(&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      2015/7205 sayılı BKK ile eklenen ibare. Yürürlük: 31/01/2015)&nbsp;
    </span>
                    pirinç,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(38)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2015/7205 sayılı BKK ile değişmeden önceki şekli)&nbsp;
    </span>
                    8502.31Rüzgar çıkış gücü ile çalışanlar (Yalnız çıkış gücü 500 kVA olanlar)
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(39)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2015/8353 sayılı Kararname ile kaldırılmadan önceki sıra)
    </span>
                    &nbsp;23- Küspe,&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (2008/14092 sayılı Kararname ile eklenen ibare. Yürürlük:
      21.09.2008)&nbsp;{" "}
    </span>{" "}
                    (18/12/2007 tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin 2303.10 pozisyonunda
                    yer alan nişastacılık artıkları ve benzeri artıklar ile 2303.30.00.00.00
                    pozisyonunda yer alan biracılık ve damıtık içki sanayinin posa ve artıkları
                    hariç)<span style={{ fontWeight: "bold" }}>(9)</span>&nbsp;tam yağlı soya
                    (fullfat), kepek, razmol, balık unu, et unu, kemik unu, kan unu, tapiyoka
                    (manyok), sorgum ve her türlü fenni karma yemler, (kedi-köpek mamaları
                    hariç) saman, yem şalgamı, hayvan pancarı, kök yemler, kuru ot, yonca, fiğ,
                    korunga, hasıl ve slajlık mısır, üçgül, yemlik lahana, yem bezelyesi ve
                    benzeri hayvan yemleri (yeşil ve kuru kaba yemler ve bunların pellet
                    şeklinde veya mevsimsel ihtiyaçlara göre bir bağlayıcı kullanılarak veya
                    kullanılmadan işlem görmüş olanları dahil),
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(41)</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;20-</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2017/9759 sayılı BKK ile kaldırılmadan önceki şekli)
    </span>
                    &nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (2015/8353 sayılı Kararname ile eklenen sıra. Yürürlük: 1/1/2016){" "}
    </span>{" "}
                    &nbsp;Gıda, Tarım ve Hayvancılık Bakanlığı tarafından tescil edilen gübreler
                    ile gübre üreticilerine bu ürünlerin içeriğinde bulunan hammaddelerin
                    teslimi.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(43)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2016/8705 sayılı BKK ile değişmeden önceki şekli)&nbsp;
    </span>
                    Buğday unu, buğday unundan imal edilen ekmekler (kepekli olanlar dahil,
                    diğer katkı maddeliler hariç), yufka,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(44)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2016/8998 sayılı Kararname ile eklenen sıra Yürürlük: 30/06/2016)&nbsp;
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(45)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (2016/9153 sayılı Kararname ile eklenen geçici madde Yürürlük: 08/09/2016)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(46)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2016/9542 sayılı Kararname ile değişmeden önceki şekli)
    </span>
                    &nbsp;5- Yukarıdaki 4 numaralı sırada yazılı mensucat, vatka, keçe ve
                    dantela, kordela, kordon ve işlemelerden mamul; iç ve dış giyim eşyası
                    (şapka, kravat, kaşkol, kemer, çorap, eldiven vb. dahil), havlu, bornoz,
                    perde, çarşaf, yastık, yorgan, battaniye, uyku tulumu, her türlü kılıf ve
                    örtüler ile bunların benzeri ev tekstil ürünleri (taşıtlarda kullanılanlar
                    dahil) (yataklar hariç),&nbsp;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(47)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2016/9542 sayılı Kararname ile değişmeden önceki şekli)
    </span>
                    &nbsp;10- Fason olarak yapılan tekstil ve konfeksiyon işleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(48)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2016/9542 sayılı Kararname ile eklenen ibare. Yürürlük: 25/11/2016)
    </span>
                    &nbsp;ile bu hizmetleri ifa edenlere hekimlerce veya hekimler vasıtasıyla
                    verilen hizmetler,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(49)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(2017/9759 sayılı Kararname ile değişmeden önceki ibare)
    </span>
                    &nbsp;31/3/2017
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(50)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (I) sayılı listenin GTİP güncellemesi&nbsp;
    </span>
                    [Bu dipnot ile 51 inci ve 52 nci dipnotlarda yapılan güncellemelerde
                    29/12/2018 tarihli ve 30640 sayılı Mükerrer Resmi Gazetede yayımlanan 516
                    sayılı Cumhurbaşkanı Kararına ekli İstatistik Pozisyonlarına Bölünmüş Türk
                    Gümrük Tarife Cetveli (TGTC) esas alınmıştır.]
                </p>
                <p>
                    - 9 uncu sıradaki "8701.90.50.00.00 Kullanılmış olanlar" pozisyonu aşağıdaki
                    tabloda gösterilen pozisyonlarda tanımlanmıştır. (2016-2017 korelasyonu)
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={168} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>ESKİ GTİP</span>
                            </p>
                        </td>
                        <td width={162} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2019 GTİP</span>
                            </p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>EŞYANIN TANIMI</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={168} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 50 00 00</p>
                        </td>
                        <td width={162} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 91 10 00 00</p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 18 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={168} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 50 00 00</p>
                        </td>
                        <td width={162} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 92 10 00 00</p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 18 kW.ı geçen fakat 37 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={168} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 50 00 00</p>
                        </td>
                        <td width={162} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 93 10 00 00</p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 37 kW.ı geçen fakat 75 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={168} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 50 00 00</p>
                        </td>
                        <td width={162} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 94 10 00 00</p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta <br /> kullanılan
                                tekerlekli traktörler (Motor gücü 75 kW.ı geçen fakat 130 kW.ı
                                geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={168} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 50 00 00</p>
                        </td>
                        <td width={162} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 95 10 00 00</p>
                        </td>
                        <td width={313} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 130 kW.ı geçenler)
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    - 17 nci sıradaki tabloda yer alan bazı satırların güncellenmiş şekli
                    aşağıda gösterilmiştir.
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={68} valign="top">
                            <p>&nbsp;</p>
                            <p>84.04</p>
                        </td>
                        <td width={575} valign="top">
                            <p>
                                [84.02 veya 84.03 Pozisyonlarındaki kazanlarla birlikte kullanılmaya
                                mahsus yardımcı cihazlar (ekonomizörler, kızgın su hasıl eden
                                <span style={{ fontWeight: "bold" }}>
              <span style={{ textDecoration: "underline" }}>ler</span>{" "}
            </span>{" "}
                                , kurum temizleme ve gaz tasarruf cihazları gibi); su buharı veya
                                diğer buhar güç üniteleri için kondansörler]
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={68} valign="top">
                            <p>&nbsp;</p>
                            <p>84.33</p>
                        </td>
                        <td width={575} valign="top">
                            <p>
                                Tarım ürünlerinin hasat ve harman edilmesine mahsus makina ve
                                cihazlar (ot ve saman balyalamaya mahsus olanlar dahil); çim
                                ve&nbsp;
                                <span style={{ fontWeight: "bold" }}>
              <span style={{ textDecoration: "underline" }}>ot</span>{" "}
            </span>{" "}
                                biçme makina ve cihazları; yumurtaları, meyvaları ve diğer tarım
                                ürünlerini ağırlık ve büyüklüklerine göre ayıran ve temizleyen
                                makina ve cihazlar (84.37 pozisyonundaki makina ve cihazlar hariç):
                                - Çimenlikler, parklar veya spor alanları için çim biçme makina ve
                                cihazları
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={68} valign="top">
                            <p>&nbsp;</p>
                            <p>84.42</p>
                        </td>
                        <td width={575} valign="top">
                            <p>
                                Levhaları, silindirleri ve diğer tabedici unsurları hazırlamaya ve
                                yapmaya mahsus makinalar, cihazlar ve teçhizat (84.56 ila 84.65
                                pozisyonlarında yer alan&nbsp;
                                <span style={{ fontWeight: "bold" }}>
              <span style={{ textDecoration: "underline" }}>makinalar</span>{" "}
            </span>{" "}
                                hariç); levhalar, silindirler ve diğer tabedici unsurlar;
                                matbaacılıkta kullanılmak üzere hazırlanmış levhalar, silindirler ve
                                litoğrafya taşları (örneğin; düz, pütürlü veya cilalı):
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={68} valign="top">
                            <p>&nbsp;</p>
                            <p>8423.30</p>
                        </td>
                        <td width={575} valign="top">
                            <p>
                                "Sabit ağırlıkları tartan basküller ve maddeyi belirli bir ağırlığa
                                göre tartarak çuval ve diğer kaplara doldurmaya mahsus baskül ve
                                teraziler" tanımına&nbsp;
                                <span style={{ fontWeight: "bold" }}>
              <span style={{ textDecoration: "underline" }}>
                (hazneli tartı cihazları
              </span>
                                    &nbsp;<span style={{ textDecoration: "underline" }}>dahil)</span>{" "}
            </span>{" "}
                                parantez içi ibaresi eklenmiştir. (2016-2017 korelasyonu)
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    <span style={{ fontWeight: "bold" }}>(51)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp;(II) sayılı listenin A bölümünün GTİP güncellemesi
    </span>
                </p>
                <p>
                    - 1/c sırasında yer alan süs balıkları TGTC' de 0301.11.00.00.00 ve
                    0301.19.00.00.00 pozisyonlarında tanımlanmıştır.&nbsp; <br /> - 18/a
                    sırasında yer alan 2202.90 pozisyonu, TGTC' de 2202.99 ve 2202.91.00.00.00
                    pozisyonlarında tanımlanmıştır.&nbsp; <br /> - 19 uncu sırada yer alan
                    2306.90.11.00.11, 2306.90.11.00.19, 2306.90.19.00.11, 2306.90.19.00.19
                    pozisyonlarında yer alan mallar TGTC' de 2306.90.11.00.00 ve
                    2306.90.19.00.00 pozisyonlarında tanımlanmıştır.&nbsp; <br /> - 20 nci
                    sırada yer alan 2501.00.91.00.11, 2501.00.91.00.12, 2501.00.91.00.19
                    pozisyonlarında yer alan mallar TGTC' de 2501.00.91.00.00 pozisyonunda
                    tanımlanmıştır. (2008-2009 Korelasyonu)
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(52)</span>
                    <span style={{ fontWeight: "bold" }}>
      &nbsp; (II) sayılı listenin B bölümünün GTİP güncellemesi
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>-&nbsp;</span>6-b sırasında yer alan
                    4302.19.95.00.19 pozisyonu, TGTC' de 4302.19.99.00.19 pozisyonunda
                    tanımlanmıştır. (2011-2012 korelasyonu)
                </p>
                <p>
                    - 19 uncu sırada yer alan 0106.90.00.90.14 pozisyonu, TGTC' de
                    0106.49.00.00.11 ve 0106.90.00.90.12 pozisyonlarında tanımlanmıştır.
                    (2011-2012 korelasyonu)
                </p>
                <p>
                    - 22 nci sıradaki tabloda yer alan bazı satırların güncellenmiş şekli
                    aşağıda gösterilmiştir.
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={127} valign="top">
                            <p>
                                2520.20.<span style={{ textDecoration: "underline" }}>0</span>
                                0.10.00
                            </p>
                        </td>
                        <td width={516} valign="top">
                            <p>Dişçilikte kullanılan alçılar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={127} valign="top">
                            <p>
                                2520.20.<span style={{ textDecoration: "underline" }}>0</span>
                                0.90.11
                            </p>
                        </td>
                        <td width={516} valign="top">
                            <p>Tıpta kullanılan alçılar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={127} valign="top">
                            <p>&nbsp;</p>
                            <p>30.05</p>
                        </td>
                        <td width={516} valign="top">
                            <p>
                                Tıpta, cerrahide, dişçilikte veya veterinerlikte kullanılan
                                eczacılık maddeleri emdirilmiş veya kaplanmış veya perakende
                                satılacak şekilde hazırlanmış veya ambalajlanmış pamuklar, gaz
                                bezleri, bandajlar ve benzeri maddeler (sargılar,&nbsp;
                                <span style={{ textDecoration: "underline" }}>
              yapışkan plasterler,
            </span>
                                &nbsp;hardal yakıları gibi)
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p />
                <div>
                    <table cellSpacing={0} cellPadding={0} border={1}>
                        <tbody>
                        <tr>
                            <td width={127} valign="top">
                                <p>&nbsp;</p>
                                <p>33.06</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    Ağız veya diş sağlığını korumaya mahsus müstahzarlar (takma
                                    dişleri temizlemeye ve onları ağızda sabit tutmaya mahsus pat ve
                                    tozlar dâhil); diş aralarını temizlemekte kullanılan iplikler (diş
                                    iplikleri),&nbsp;
                                    <span style={{ textDecoration: "underline" }}>
                perakende satılacak
              </span>
                                    &nbsp;
                                    <span style={{ textDecoration: "underline" }}>
                hale getirilmiş bireysel kullanıma mahsus ambalajlarda olanlar
              </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>3407.00.00.90.11</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    Dişçi<span style={{ textDecoration: "underline" }}>lik</span>
                                    &nbsp;mumu
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>3701.10.00.00.00</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    -X- ışınları için filmler (2009-2010 korelasyonu; tıpta,
                                    dişçilikte veya veterinerlikte kullanılanlar dışındakiler
                                    kararname kapsamında değildir.)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>
                                    8421.29.<span style={{ textDecoration: "underline" }}>8</span>
                                    0.00.11
                                </p>
                            </td>
                            <td width={516} valign="top">
                                <p>Diyalizör</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>&nbsp;</p>
                                <p>90.21</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    Ortopedik cihazlar (Koltuk değnekleri, cerrahi kuşaklar ve fıtık
                                    bağları dahil); cebireler, gudyerler ve kırıklara mahsus diğer
                                    cihazlar; protez organlar;&nbsp;
                                    <span style={{ textDecoration: "underline" }}>işitme</span>&nbsp;
                                    <span style={{ textDecoration: "underline" }}>engellilerin</span>
                                    &nbsp;işitmesini kolaylaştırmaya mahsus cihazlar ve vücut kusur
                                    veya noksanlığını gidermek amacıyla üstte veya elde taşınan veya
                                    vücudun içine yerleştirilen diğer cihazlar (Aksam, parça ve
                                    aksesuarlar hariç)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>9402.10.00.00.11</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    Dişçi<span style={{ textDecoration: "underline" }}>lik</span>
                                    &nbsp;koltukları
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={127} valign="top">
                                <p>&nbsp;</p>
                                <p>9603.21.00.00.00</p>
                            </td>
                            <td width={516} valign="top">
                                <p>
                                    Diş fırçaları&nbsp;
                                    <span style={{ textDecoration: "underline" }}>
                (takma damak fırçaları dahil) [
              </span>
                                    2018-2019 korelasyonu ile 9603.21.00.00.11 ve 9603.21.00.00.19
                                    pozisyonlarında tanımlanmıştır.] [2008 TGTC' sinde eşya tanımı
                                    "Diş fırçaları" şeklinde iken, 2009 yılında eşyanın tanımına
                                    (takma damak fırçaları dahil) ibaresi de eklenmiştir.]
                                </p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p>
                        - 28 inci sıradaki tabloda yer alan bazı satırların güncellenmiş şekli
                        aşağıda gösterilmiştir.
                    </p>
                    <table cellSpacing={0} cellPadding={0} border={1}>
                        <tbody>
                        <tr>
                            <td width={225} valign="top">
                                <p>&nbsp;</p>
                                <p>8424.81 pozisyonu</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8424.82.10.00.00, 8424.82.90.00.00, 8424.41.00.10.00, <br />{" "}
                                    8424.41.00.90.00, 8424.49.10.00.00 ve 8424.49.90.00.00 <br />{" "}
                                    pozisyonlarında tanımlanmıştır.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8428.20.<span style={{ textDecoration: "underline" }}>8</span>
                                    0.90.00
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    Diğerleri (Yalnız tarımda kullanılmak üzere özel olarak imal
                                    edilmiş pnömatik elevatörler ve konveyörler)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>8428.90.95.90.11</p>
                            </td>
                            <td width={418} valign="top">
                                2009-2010 korelasyonunda 8428.90.90.90.00 pozisyonunda "Diğerleri"
                                tanımıyla yer almıştır.
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8432.10.
                                    <span style={{ textDecoration: "underline" }}>00.00.00</span>
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>Pulluklar</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>&nbsp;</p>
                                <p>8432.30 pozisyonu</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8432.31.00.00.00, 8432.39.19.00.00, 8432.39.11.00.11, <br />{" "}
                                    8432.39.11.00.12 ve 8432.39.90 pozisyonlarında tanımlanmıştır.{" "}
                                    <br /> (2016-2017 korelasyonu)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>8432.40 pozisyonu</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8432.41.00.00.00 ve 8432.42.00.00.00 pozisyonlarında
                                    tanımlanmıştır.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>8433.20</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    Diğer çim biçme makinaları (traktörlere monte edilen parmaklı
                                    biçme makinaları dahil)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8433.30.
                                    <span style={{ textDecoration: "underline" }}>00.00.00</span>
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>Ot hazırlama makina ve cihazları</p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8433.40.
                                    <span style={{ textDecoration: "underline" }}>00.00.00</span>
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    Ot ve saman balyalama makina ve cihazları (ot ve samanları
                                    toplayıp demet veya balya yapmaya mahsus olanlar dahil)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>8433.51.00.00.00</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8433.51.00.00.11, 8433.51.00.00.19, 8433.51.00.00.21, <br />{" "}
                                    8433.51.00.00.29 pozisyonlarına ayrılmıştır. (2017-2018 <br />{" "}
                                    korelasyonu)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>8433.53</p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    Kök ve yumru&nbsp;
                                    <span style={{ textDecoration: "underline" }}>hasat</span>
                                    &nbsp;makinaları
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8433.59.30.00.11, <br /> 8433.59.30.00.12, <br />{" "}
                                    8433.59.30.00.13, <br /> 8433.59.80.00.11, <br />{" "}
                                    8433.59.80.00.12, <br /> 8433.59.80.00.13 ve <br />{" "}
                                    8433.59.80.00.19 pozisyonları
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8433.59.85.00.00 pozisyonunda toplanmıştır. (2008-2009 <br />{" "}
                                    korelasyonu) <br /> 2017-2018 korelasyonu ile de 8433.59.85.00.11,{" "}
                                    <br /> 8433.59.85.00.19, 8433.59.85.00.21, 8433.59.85.00.29,{" "}
                                    <br /> 8433.59.85.00.39 pozisyonlarına ayrılmıştır.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width={225} valign="top">
                                <p>
                                    8436.80.91.00.00, <br /> 8436.80.99.00.11, <br /> 8436.80.99.00.12
                                    ve <br /> 8436.80.99.00.13 pozisyonları
                                </p>
                            </td>
                            <td width={418} valign="top">
                                <p>
                                    8436.80.90.00.00 pozisyonunda toplanmıştır. (2008-2009 <br />{" "}
                                    korelasyonu)
                                </p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p>
                        &nbsp;- 28 inci sıradaki tabloda yer alan traktörlerin yeni GTİP
                        numaraları ile eşya tanımları aşağıdaki tabloda ayrıca gösterilmiştir.
                        (2016-2017 korelasyonu)
                    </p>
                </div>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={166} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>ESKİ GTİP</span>
                            </p>
                        </td>
                        <td width={160} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2019 GTİP</span>
                            </p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>EŞYANIN TANIMI</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>8701.10.00.00.00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>8701.10.00.00.00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>Tek akslı traktörler</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 11 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 91 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 18 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 20 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 92 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 18 kW.ı geçen fakat 37 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 25 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 93 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 37 kW.ı geçen fakat 75 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 31 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 93 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 37 kW.ı geçen fakat 75 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 35 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 94 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 75 kW.ı geçen fakat 130 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 39 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 94 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 75 kW.ı geçen fakat 130 kW.ı geçmeyenler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={166} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 90 39 00 00</p>
                        </td>
                        <td width={160} valign="top">
                            <p>&nbsp;</p>
                            <p>8701 95 10 00 00</p>
                        </td>
                        <td width={317} valign="top">
                            <p>
                                Tekerlekli zirai traktörler ve ormancılıkta kullanılan tekerlekli
                                traktörler (Motor gücü 130 kW.ı geçenler)
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (53) (2017/10468 sayılı Kararname ile eklenen sıra. Yürürlük: 1/8/2017)
    </span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (54) (2018/11333 sayılı Kararname ile eklenen ibare. Yürürlük: 3/2/2018)
    </span>
                    &nbsp;ve denizaltı karayolu tünellerin
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (55) (2017/9759 sayılı Kararname ile mülga olan sıra. Yürürlük:
      3/2/2017)&nbsp; (2018/11658 sayılı Kararname ile yeniden eklenen sıra.
      Yürürlük: 1/6/2018)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(56)</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;(2018/11674&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      sayılı Kararname ile eklenen geçici madde. Yürürlük:
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> &nbsp;5/5/2018) </span> <br />
                    <span style={{ fontWeight: "bold" }}>Geçici Madde 3-</span>&nbsp;&nbsp;
                    <span style={{ fontWeight: "bold" }}>(1)</span>&nbsp; Bu Kararın 1 inci
                    maddesinin birinci fıkrasının (a) bendinde belirtilen vergi oranına tabi
                    konutların, 31/10/2018 tarihine kadar (bu tarih dahil) teslimlerinde, aynı
                    fıkranın (c) bendinde belirtilen vergi oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(57)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (2018/11750 sayılı&nbsp;Kararname ile değişmeden önceki ibare. Yürürlük:
      18/5/2018)&nbsp;
    </span>
                    konutların <br /> Bu ibare, "konutlar ile işyerlerinin (bina ve/veya
                    bağımsız bölüm şeklinde olanlar)" şeklinde değiştirilmiştir.&nbsp; <br />{" "}
                    Dolayısıyla, konutlar için yürürlük tarihi 5/5/2018; işyerleri (bina ve/veya
                    bağımsız bölüm şeklinde olanlar) için yürürlük tarihi 18/5/2018 tarihidir.
                    31/10/2018 tarihine kadar (bu tarih dahil) bunların teslimlerinde % 8
                    indirimli KDV oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(58)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (14/08/2018 tarihli ve 22 sayılı Cumhurbaşkanı Kararı ile eklenen geçici
      madde. Yürürlük: 15/8/2018)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(59)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (31/10/2018 tarihli ve 287 sayılı Cumhurbaşkanı Kararının eki Kararın 2
      nci maddesiyle değişen ibare. Yürürlük: 31/10/2018)
    </span>
                    &nbsp;"31/10/2018"
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (60) (18/12/2018 tarihli ve 475 sayılı Cumhurbaşkanı Kararının 1 inci
      maddesiyle değişmeden önceki şekli)
    </span>{" "}
                    <br /> "8- Gazete ve dergiler (21/6/1927 tarihli ve 1117 sayılı Kanun
                    hükümlerine göre poşetlenerek satılanların tesliminde bu Kararın 1 inci
                    maddesinin (a) bendinde öngörülen vergi oranı uygulanır.)&nbsp;
                    <span style={{ fontWeight: "bold" }}>(32)</span>&nbsp;bu yayınların
                    elektronik ortamda satışı (elektronik gazete ve dergi okuyucu, tablet ve
                    benzerleri hariç),"
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (61) (18/12/2018 tarihli ve 475 sayılı Cumhurbaşkanı Kararının 2 nci
      maddesiyle değişmeden önceki şekli)
    </span>{" "}
                    <br /> "14- Kitap ve benzeri yayınlar (21/6/1927 tarihli ve 1117 sayılı
                    Kanun hükümlerine göre poşetlenerek satılanların tesliminde bu Kararın 1
                    inci maddesinin (a) bendinde öngörülen vergi oranı uygulanır.)&nbsp;
                    <span style={{ fontWeight: "bold" }}>(36)</span>&nbsp;elektronik kitap
                    (e-kitap) ve benzeri yayınların elektronik ortamda satışı (elektronik kitap
                    okuyucu, tablet ve benzerleri hariç), kurşun kalem, boya kalemleri, sulu
                    boya ve pastel boyalar, okul defterleri, silgi, kalemtıraş, cetvel, pergel,
                    gönye, iletki,
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (62) (30/12/2018 tarihli ve 535 sayılı Cumhurbaşkanı Kararınının eki
      Kararın 2 nci maddesiyle değişen ibare. Yürürlük: 1/1/2019)
    </span>
                    &nbsp;"31/12/2018"
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (63) (20/3/2019 tarihli ve 843 sayılı Cumhurbaşkanı Kararının eki Kararın
      2 nci maddesiyle değişen ibare. Yürürlük: 1/4/2019)
    </span>
                    "31/3/2019"
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (65) (30/4/2019 tarihli ve 1013 sayılı Cumhurbaşkanı Kararının eki Kararın
      1 inci maddesiyle değişmeden önceki şekli)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>"12-Konut yapı
                    kooperatiflerine yapılan inşaat taahhüt işleri,"
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (66) (30/4/2019 tarihli ve 1013 sayılı Cumhurbaşkanı Kararının eki Kararın
      1 inci maddesiyle eklenen ibareden önceki hali)
    </span>
                </p>
                <p>
                    "
                    <span style={{ fontWeight: "bold" }}>
      5- (2016/9542 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      25/11/2016)&nbsp;
    </span>
                    Yukarıdaki 4 numaralı sırada yazılı mensucat, vatka, keçe ve dantela,
                    kordela, kordon ve işlemelerden mamul; iç ve dış giyim eşyası (şapka,
                    kravat, kaşkol, şal, eşarp, kemer, çorap, eldiven vb. dahil), omuz vatkası,
                    astar, apolet, ilikleme tertibatı, cep, kol, yaka, rozet ve fırfır ile
                    bunların benzerleri, havlu, bornoz, perde, çarşaf, yastık, yorgan,
                    battaniye, uyku tulumu, her türlü kılıf ve örtüler ile bunların benzeri ev
                    tekstil ürünleri (taşıtlarda kullanılanlar dahil) (yataklar hariç) ile
                    kıymetli taş ve madenler hariç her nevi maddeden mamul fermuar, çıtçıt,
                    düğme, kopça, boncuk ve benzerleri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(46)</span>"
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(67)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (01/10/2019 tarihli ve 1594 sayılı Cumhurbaşkanı Kararı ile eklenen sıra.
      Yürürlük: 02/10/2019)
    </span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (68) (02/01/2020 tarihli ve 1994 sayılı Cumhurbaşkanı Kararı ile eklenen
      ifade.&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 02/01/2020)</span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (69) (02/01/2020 tarihli ve 1994 sayılı Cumhurbaşkanı Kararının 2 nci
      maddesiyle değişmeden önceki şekli.&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 02/01/2020&nbsp;)</span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      "6- (2011/1673 sayılı BKK ile değişen sıra. Yürürlük: 28/04/2011)&nbsp;
    </span>
                    İlgili mevzuata göre toptancı hallerinde faaliyette bulunanlara ve bunlar
                    tarafından gerçek usule tabi katma değer vergisi mükelleflerine yapılan taze
                    sebze ve meyve (mamulleri hariç) teslimleri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(13)"</span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(70)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (02/01/2020 tarihli ve 1994 sayılı Cumhurbaşkanı Kararı ile eklenen
      ifade.&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> Yürürlük: 02/01/2020&nbsp;) </span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (71) (30/08/2020 tarihli ve 2913 sayılı Cumhurbaşkanı Kararı ile eklenen
      ifade. Yürürlük:&nbsp; 30/08/2020)
    </span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (72) (23/12/2020 tarihli ve 3318 sayılı Cumhurbaşkanı Kararının 1 inci
      maddesiyle değişmeden önceki şekli.&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 01/01/2021)</span>
                    &nbsp;31/12/2020
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(73)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (29/01/2021 tarihli ve 3470 sayılı Cumhurbaşkanı Kararı ile eklenen ifade.
      Yürürlük: 30/01/2021)
    </span>
                </p>
                <p>
                    6306 sayılı Kanun kapsamında riskli yapıların bulunduğu yerlerde dönüşüm
                    projeleri çerçevesinde taşınmaz maliklerine ait mevcut inşaat alanının bir
                    buçuk katına kadar olan yeni inşaat alanında yapılacak olan konutlara
                    ilişkin inşaat taahhüt işleri,
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (74)&nbsp;Değişmeden önceki şekli :&nbsp;(3318 sayılı Cumhurbaşkanı
      Kararıyla değişen ibare;&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 01.01.2021</span>
                    <span style={{ fontWeight: "bold" }}>)&nbsp;</span>31/5/2021{" "}
                    <span style={{ fontWeight: "bold" }}> (72) </span> &nbsp;tarihine kadar (bu
                    tarih dahil);
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(75)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                    &nbsp;c) Ekli ll sayılı listenin "B) DİĞER MAL VE HİZMETLER" bölümünün 25
                    inci sırasında yer alan geceleme hizmetleri,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(76)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :&nbsp;</span>
                    30.06.2021
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (77) Değişmeden önceki şekli : (4062 sayılı Cumhurbaşkanı Kararıyla
      değişen ibare;
    </span>
                    <span style={{ fontWeight: "bold" }}>Yürürlük: 01.06.2021</span>
                    <span style={{ fontWeight: "bold" }}>)&nbsp;</span>(1)31/7/2021{" "}
                    <span style={{ fontWeight: "bold" }}> (74) </span>
                </p>
                <p>
    <span style={{ fontWeight: "bold" }}>
      (78) Değişmeden önceki şekli: (4105 sayılı Cumhurbaşkanı Kararı ile
      değişen ibare; Yürürlük: 22.06.2021)
    </span>
                    31/7/2021<span style={{ fontWeight: "bold" }}>(76)</span>
                </p>
                <p align="left">
                    <span style={{ fontWeight: "bold" }}>(79)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (30/09/2021 tarihli ve 4517 sayılı Cumhurbaşkanı Kararı ile eklenen
      ifade.&nbsp;
    </span>
                    &nbsp; <span style={{ fontWeight: "bold" }}> Yürürlük: 01/10/2021 ) </span>
                </p>
                <p align="left">
    <span style={{ fontWeight: "bold" }}>
      (80)<span style={{ fontWeight: 400 }}>&nbsp;</span>(26/11/2021 tarihli ve
      4862 sayılı Cumhurbaşkanı Kararı ile eklenen ifade.&nbsp;Yürürlük:
      01/12/2021 ){" "}
    </span>
                </p>
                <p align="left">
                    <span style={{ fontWeight: "bold" }}>(81)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli:</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (31/12/2021 tarihli ve 5047 sayılı Cumhurbaşkanı Kararı ile değişen ibare;
      Yürürlük: 1/1/2022){" "}
    </span>{" "}
                    &nbsp;31/12/2021
                </p>
                <p>
                    &nbsp;
                    <span style={{ fontWeight: "bold" }}>
      (82) (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile eklenen
      ifade. Yürürlük: 14/02/2022)
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(83)&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli:</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>
                    <span style={{ fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> değişen ibare; </span>{" "}
                    <span style={{ fontWeight: "bold" }}>&nbsp;Yürürlük: 14/02/2022)</span>
                </p>
                <p
                    style={{
                        marginTop: "0cm",
                        marginRight: "0cm",
                        marginBottom: "6.0pt",
                        marginLeft: "0cm",
                        textAlign: "justify",
                        background: "white"
                    }}
                >
                    <span style={{ fontWeight: "bold" }}>&nbsp;(2)</span>&nbsp;(I) sayılı
                    listenin{" "}
                    <s>
                        {" "}
                        <span style={{ color: "red" }} />{" "}
                    </s>{" "}
                    <span style={{ color: "red" }}>&nbsp;</span>16 ncı ve 17 nci sıralarında
                    sayılan işlemler hariç olmak üzere finansal kiralama işlemlerinde, işleme
                    konu olan malın tabi olduğu katma değer vergisi oranı&nbsp; &nbsp;
                    &nbsp;uygulanır.&nbsp;
                </p>
                <p
                    style={{
                        marginTop: "0cm",
                        marginRight: "0cm",
                        marginBottom: "6.0pt",
                        marginLeft: "0cm",
                        textAlign: "justify",
                        background: "white"
                    }}
                >
                    <span style={{ fontWeight: "bold" }}>(84)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli:</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;{" "}
    </span>{" "}
                    <span style={{ fontWeight: "bold", textAlign: "-webkit-left" }}>
      değişen ibare;
    </span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;Yürürlük: 14/02/2022)</span>
                </p>
                <p>
                    (I) sayılı listenin 2/a sırasında yer alan ürünlerin perakende safhadaki
                    teslimlerinde bu maddenin (a) bendinde öngörülen vergi oranı, 1, 2/b ve 3
                    üncü sıralarında yer alan ürünlerin perakende safhadaki teslimlerinde ise
                    (c) bendinde öngörülen vergi oranı uygulanır.
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(85)</span>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :&nbsp;</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> değişen ibare; </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)&nbsp;
    </span>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(4)&nbsp;</span>
                    <span style={{ textAlign: "justify" }}>
      Perakende safhadaki teslimden maksat; teslimi yapılan ürünlerin aynen veya
      işlendikten sonra satışını yapanlar ile işletmelerinde kullanacak olanlar
      dışındakilere satılmasıdır. Ürünleri, aynen ya da işlendikten sonra
      satanlar ile işletmesinde kullanacak olanların gerçek usulde katma değer
      vergisi mükellefi olmamaları halinde bunlara yapılan teslimler de
      perakende teslim sayılır.
    </span>
                </p>
                <p>
    <span style={{ textAlign: "justify" }}>
      <strong>(86) Değişmeden önceki şekli :</strong>&nbsp;
    </span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> değişen madde; </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)
    </span>
                </p>
                <p>
                    <span style={{ textAlign: "justify" }} />
                    <strong>(5)</strong>&nbsp;(I) sayılı listenin 9 uncu sırasında yer alan
                    "kullanılmış" deyimi, 4760 sayılı Özel Tüketim Vergisi Kanununa göre özel
                    tüketim vergisine tabi olmayan taşıtları ifade eder.
                </p>
                <p>
                    <strong>(88)&nbsp;</strong>
                    <span style={{ textAlign: "justify" }}>
      <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>
                    <span style={{ fontWeight: "bold" }}>değişen madde;</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)&nbsp;
    </span>
                    1- Kuru üzüm, kuru incir, kuru kayısı, ceviz, fındık, antep fıstığı, çam
                    fıstığı, yer fıstığı, kestane, leblebi, ayçiçeği çekirdeği, kabak çekirdeği,
                </p>
                <p>
                    <strong>(89)&nbsp;</strong>
                    <span style={{ textAlign: "justify" }}>
      <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify" }} />
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> değişen madde; </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)&nbsp;
    </span>
                    4- Buğday unu, yufka, ekmek (buğday unu, kepek, su, tuz, maya, şeker,
                    enzimler, enzim kaynağı olarak malt unu, vitalgluten ve Türk Gıda Kodeksine
                    göre izin verilen katkı maddeleri ile toplamda %5 oranını geçmemek kaydıyla
                    çeşni maddeleri, diğer tahıllar, soya unu, baklagil unları, yağ, süt, süt
                    ürünleri, bitkisel lif ve benzeri maddeler ilave edilmek suretiyle imal
                    edilen ekmekler),
                </p>
                <p />
                <p
                    style={{
                        margin: "0px 0px 20px",
                        color: "#777777",
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: 13,
                        fontStyle: "normal",
                        fontVariantLigatures: "normal",
                        fontVariantCaps: "normal",
                        fontWeight: 400,
                        letterSpacing: "normal",
                        orphans: 2,
                        textAlign: "start",
                        textIndent: 0,
                        textTransform: "none",
                        whiteSpace: "normal",
                        widows: 2,
                        wordSpacing: 0,
                        WebkitTextStrokeWidth: 0,
                        textDecorationThickness: "initial",
                        textDecorationStyle: "initial",
                        textDecorationColor: "initial"
                    }}
                >
                    <strong>(90)&nbsp;</strong>
                    <span style={{ textAlign: "justify" }}>
      <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify" }} />
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
    </span>{" "}
                    <span style={{ fontWeight: "bold" }}> değişen madde; </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)&nbsp;
    </span>
                    6- İlgili mevzuata göre; toptancı hallerinde faaliyette bulunanlara yapılan
                    taze sebze ve meyve (mamulleri hariç) teslimleri, toptancı halleri ve su
                    ürünleri toptan satış yerlerinde faaliyette bulunanlara yapılan balık
                    teslimleri ile bu malların bunlar tarafından gerçek usule tabi katma değer
                    vergisi mükelleflerine teslimi,
                </p>
                <p>
                    <strong>(91)&nbsp;</strong>
                    <span style={{ textAlign: "justify" }}>
      <span style={{ fontWeight: "bold" }} />{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile yapılan bazı
      düzenlemeler
    </span>
                    <span style={{ fontWeight: "bold" }}>;</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 14/02/2022)&nbsp;
    </span>{" "}
                    <span style={{ textAlign: "justify" }}>
      {" "}
                        13 Şubat 2022 tarihinde yayımlanan 5189 sayılı&nbsp;{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify" }}>
      Mal ve Hizmetlere Uygulanacak Katma Değer Vergisi Oranlarının Tespitine
      İlişkin Kararda Değişiklik Yapılmasına Dair&nbsp;
    </span>{" "}
                    <span style={{ textAlign: "justify" }}>
      {" "}
                        Cumhurbaşkanı Kararı ile II sayılı listenin "A) GIDA MADDELERİ" bölümünün
      sonunda yer alan "{" "}
    </span>{" "}
                    <span style={{ textAlign: "justify" }}>
      Bu bölümdeki malların (I) sayılı listede de yer alması halinde, (I) sayılı
      listede belirlenen oranlar uygulanır." şeklindeki hüküm yürürlükten
      kaldırılmıştır.
    </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    Ayrıca; (I) sayılı listede "B) DİĞER MAL VE HİZMETLER" başlığıyla bölüm
                    ihdas edilmiş, halihazırda söz konusu listede yer alan sıralar, bu bölüm
                    başlığı altında aynı sıra ile tasnif edilmiş; (II) sayılı listenin "A) GIDA
                    MADDELERİ" bölümünde yer alan sıralar bu listeden kaldırılarak bölüm başlığı
                    ile birlikte olduğu gibi (I) sayılı listeye eklenmiş ve (II) sayılı listenin
                    "B) DİĞER MAL VE HİZMETLER" bölüm başlığı yürürlükten kaldırılmıştır.
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <strong>(92)&nbsp;</strong>
                    <span style={{ fontWeight: "bold" }} />{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 1.maddesi ile
      kaldırılan fıkra
    </span>
                    <span style={{ fontWeight: "bold" }}>;</span>
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}>
      &nbsp;Yürürlük: 01/04/2022;{" "}
    </span>
                    <strong>
                        Bu Kararın yürürlük tarihinden önce yapı ruhsatı alınmış veya kamu kurum
                        ve kuruluşları ile bunların iştirakleri tarafından ihalesi yapılmış
                        projeler kapsamında inşa edilen konutlar için 1 inci ve 4 üncü maddelerde
                        kaldırılan veya değiştirilen hükümlerin uygulanmasına devam olunur.
                    </strong>{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}> ) </span>{" "}
                    <span style={{ fontWeight: "bold" }}>
      (6) (2017/9759 sayılı Kararnamenin 2 nci maddesiyle değişen fıkra.
      Yürürlük: 03/02/2017)&nbsp;
    </span>
                    (I) sayılı listenin "B) DİĞER MAL VE HİZMETLER'' bölümünün
                    <span
                        style={{
                            fontSize: "11.0pt",
                            lineHeight: "107%",
                            fontFamily: '"Calibri",sans-serif',
                            msoAsciiThemeFont: "minor-latin",
                            msoFareastFontFamily: "Calibri",
                            msoFareastThemeFont: "minor-latin",
                            msoHansiThemeFont: "minor-latin",
                            msoBidiFontFamily: '"Times New Roman"',
                            msoBidiThemeFont: "minor-bidi",
                            color: "red",
                            msoAnsiLanguage: "TR",
                            msoFareastLanguage: "EN-US",
                            msoBidiLanguage: "AR-SA"
                        }}
                    >
      &nbsp;
    </span>
                    &nbsp;11 inci sırasında yer alan net alanı 150 m2'ye kadar konutlardan;
                    10/7/2004 tarihli ve 5216 sayılı Büyükşehir Belediyesi Kanunu kapsamındaki
                    büyükşehirlerde (16/5/2012 tarihli ve 6306 sayılı Afet Riski Altındaki
                    Alanların Dönüştürülmesi Hakkında Kanun kapsamında rezerv yapı alanı ve
                    riskli alan olarak belirlenen yerler ile riskli yapıların bulunduğu yerler
                    hariç), lüks veya birinci sınıf inşaat olarak yapılan ve ruhsatın sonradan
                    revize edilip inşaat kalitesinin yükseltilmesi hali de dâhil olmak üzere,
                    yapı ruhsatının alındığı tarihte, üzerine yapıldığı arsanın 29/7/1970
                    tarihli ve 1319 sayılı Emlak Vergisi Kanununun 29 uncu maddesine istinaden
                    tespit edilen arsa birim m2 vergi değeri; <strong>(*)</strong>
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(i)</span>&nbsp;Yapı ruhsatı 1/1/2013
                    ila 31/12/2016 tarihleri arasında alınan konut inşaatı projeleri ile kamu
                    kurum ve kuruluşları ile bunların iştirakleri tarafından ihalesi 1/1/2013
                    tarihinden itibaren yapılacak konut inşaatı projelerinde;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;Beşyüz Türk Lirası ile
                    bin Türk Lirası (bin Türk Lirası hariç) arasında olan konutların tesliminde
                    bu maddenin birinci fıkrasının (c) bendinde belirtilen vergi oranı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;Bin Türk Lirası ve
                    üzerinde olan konutların tesliminde bu maddenin birinci fıkrasının (a)
                    bendinde belirtilen vergi oranı,
                </p>
                <p>uygulanır.</p>
                <p>
                    <span style={{ fontWeight: "bold" }}>(ii)</span>&nbsp;Yapı ruhsatı 1/1/2017
                    tarihinden (bu tarih dâhil) sonra alınan konut inşaatı projeleri ile kamu
                    kurum ve kuruluşları ile bunların iştirakleri tarafından ihalesi 1/1/2017
                    tarihinden itibaren yapılacak konut inşaatı projelerinde;
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>a)</span>&nbsp;Bin Türk Lirası ile iki
                    bin Türk Lirası (iki bin Türk Lirası dâhil) arasında olan konutların
                    tesliminde bu maddenin birinci fıkrasının (c) bendinde belirtilen vergi
                    oranı,
                </p>
                <p>
                    <span style={{ fontWeight: "bold" }}>b)</span>&nbsp;İki bin Türk Lirasının
                    üzerinde olan konutların tesliminde bu maddenin birinci fıkrasının (a)
                    bendinde belirtilen vergi oranı,
                </p>
                <p>
                    uygulanır.&nbsp;<span style={{ fontWeight: "bold" }}>(**)</span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <strong>
        <em>(*)&nbsp;</em>
      </strong>
      <em>
        <span style={{ textAlign: "justify" }}>
          <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
            &nbsp;{" "}
        </span>{" "}
          <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          (13/02/2022 tarihli ve 5189 sayılı Cumhurbaşkanı Kararı ile&nbsp;
        </span>
        <span style={{ fontWeight: "bold" }}>değişen madde;</span>
        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          &nbsp;Yürürlük: 14/02/2022)
        </span>{" "}
      </em>{" "}
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        <strong>(6)&nbsp;</strong>(I) sayılı listenin 11 inci sırasında yer alan
        net alanı 150 m2'ye kadar konutlardan; 10/7/2004 tarihli ve 5216 sayılı
        Büyükşehir Belediyesi Kanunu kapsamındaki büyükşehirlerde (16/5/2012
        tarihli ve 6306 sayılı Afet Riski Altındaki Alanların Dönüştürülmesi
        Hakkında Kanun kapsamında rezerv yapı alanı ve riskli alan olarak
        belirlenen yerler ile riskli yapıların bulunduğu yerler hariç), lüks
        veya birinci sınıf inşaat olarak yapılan ve ruhsatın sonradan revize
        edilip inşaat kalitesinin yükseltilmesi hali de dâhil olmak üzere, yapı
        ruhsatının alındığı tarihte, üzerine yapıldığı arsanın 29/7/1970 tarihli
        ve 1319 sayılı Emlak Vergisi Kanununun 29 uncu maddesine istinaden
        tespit edilen arsa birim m2 vergi değeri;{" "}
      </em>
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        <span style={{ fontWeight: "bold" }}>
          (**)&nbsp;Değişmeden önceki şekli:&nbsp;
        </span>
        (6)&nbsp;
          <span style={{ fontWeight: "bold" }}>
          (2012/4116 sayılı Kararname ile eklenen fıkra. Yürürlük:
          01/01/2013)&nbsp;
        </span>
        (I) sayılı listenin 11 inci sırasında yer alan net alanı 150 m2'ye kadar
        konutlardan; 10/7/2004 tarihli ve 5216 sayılı Büyükşehir Belediyesi
        Kanunu kapsamındaki büyükşehirlerde (16/5/2012 tarihli ve 6306 sayılı
        Afet Riski Altındaki Alanların Dönüştürülmesi Hakkında Kanun kapsamında
        rezerv yapı alanı ve riskli alan olarak belirlenen yerler ile riskli
        yapıların bulunduğu yerler hariç), lüks veya birinci sınıf inşaat olarak
        yapılan ve ruhsatın sonradan revize edilip inşaat kalitesinin
        yükseltilmesi hali de dahil olmak üzere, yapı ruhsatının alındığı
        tarihte, üzerine yapıldığı arsanın 1319 sayılı Emlak Vergisi Kanununun
        29 uncu maddesine istinaden tespit edilen arsa birim m2 vergi değeri;{" "}
      </em>{" "}
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        {" "}
          a) Beşyüz Türk Lirası ile bin Türk Lirası (bin Türk Lirası hariç)
        arasında olan konutların tesliminde bu maddenin birinci fıkrasının (c)
        bendinde belirtilen vergi oranı,{" "}
      </em>
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        {" "}
          b) Bin Türk Lirası ve üzerinde olan konutların tesliminde bu maddenin
        birinci fıkrasının (a) bendinde belirtilen vergi oranı,{" "}
      </em>
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em> uygulanır.* </em>
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        {" "}
          *&nbsp;Yürürlük: Yapı ruhsatı 1/1/2013 tarihinden itibaren alınan konut
        inşaatı projeleri ile kamu kurum ve kuruluşları ile bunların iştirakleri
        tarafından ihalesi bu tarihten itibaren yapılacak konut inşaatı
        projelerine ilişkin konut teslimlerine uygulanmak üzere yayımı tarihinde
        (01/01/2013)
      </em>
    </span>
                    <em />
                </p>
                <p>
                    <strong>
                        (93){" "}
                        <span style={{ textAlign: "justify" }}>
        <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                            &nbsp; (
        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 2.maddesi ile
          değiştirilen sıra
        </span>
        <span style={{ fontWeight: "bold" }}>;</span>
        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          &nbsp;Yürürlük: 01/04/2022)
        </span>
      </span>{" "}
                    </strong>
                    Buğday, arpa, mısır, çeltik, fasulye, yer fıstığı, ayçiçeği, soya, şeker
                    pancarı, patates, pamuk, nohut, yonca, korunga, adi ve diğer fiğler, sorgum,
                    sudan otu ve sorgum-sudan melezinin sertifikalı tohumlukları ile sertifikalı
                    meyve fidanları,
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <strong>
                        (94) <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp; (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 3.maddesi ile
        değiştirilen cümle
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022){" "}
                            <span style={{ fontWeight: "bold" }}>
          {" "}
                                (21/3/2019 tarihli ve 845 sayılı Cumhurbaşkanı Kararının 1 inci
          maddesiyle eklenen cümle. Yürürlük: 22/3/2019)&nbsp;
        </span>
      </span>
                    </strong>
                    İkinci el motorlu kara taşıtı ticaretiyle iştigal eden mükelleflerce bu
                    Kararın birinci maddesinin (a) bendinde belirtilen vergi oranı uygulanarak
                    satın alınan araçların tesliminde, bu araçların alımında uygulanan katma
                    değer vergisi oranı uygulanır.)&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (*) </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
    <span style={{ fontSize: "x-small" }}>
      <span style={{ fontWeight: "bold" }}>
        <em>(*)</em>
      </span>
      <em>
        <span style={{ fontWeight: "bold" }}>
          &nbsp;(2008/13426 sayılı BKK'nın 2 nci maddesi. Yürürlük : 07/04/2008)
        </span>
          &nbsp;Katma Değer Vergisi Kanununun 30 uncu maddesinin (b) bendine göre
        binek otomobillerin alımında yüklenilen katma değer vergisini indirim
        hakkı bulunan mükelleflerin, kiralamak veya çeşitli şekillerde işletmek
        üzere iktisap ettikleri ve 31/12/2007 tarihi itibarıyla aktiflerinde
        veya envanterlerinde bulunan binek otomobillerinin iktisap tarihinden
        itibaren 2 yıl geçtikten sonra teslime konu olması halinde bu teslimde %
        1 katma değer vergisi oranı uygulanır.{" "}
      </em>{" "}
    </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <strong>
                        (95) <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;(
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 4.maddesi ile
        değiştirilen ibare
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022
        <strong>
          ; Bu Kararın yürürlük tarihinden önce yapı ruhsatı alınmış veya kamu
          kurum ve kuruluşları ile bunların iştirakleri tarafından ihalesi
          yapılmış projeler kapsamında inşa edilen konutlar için 1 inci ve 4
          üncü maddelerde kaldırılan veya değiştirilen hükümlerin uygulanmasına
          devam olunur.
        </strong>
        ){" "}
      </span>{" "}
                    </strong>{" "}
                    Net alanı 150 m2'ye kadar konut teslimleri{" "}
                    <span style={{ textAlign: "justify", fontWeight: "bold" }}> </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
    <span style={{ fontWeight: "bold" }}>
      <strong>
        (96) Kaldırılmadan önceki şekli : (
        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 5.maddesi ile
          kaldırılan sıra
        </span>
        ;
        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
          &nbsp;Yürürlük: 01/04/2022)
        </span>{" "}
      </strong>{" "}
        (2017/9759 sayılı Kararname ile değişen sıra. Yürürlük: 03/02/2017)&nbsp;{" "}
    </span>{" "}
                    Yatlar, kotralar, tekneler ve gezinti gemileri,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(*) (**)</span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
    <span style={{ fontSize: "x-small" }}>
      <span style={{ fontWeight: "bold" }}>
        <em>(*)</em>
      </span>
      <em>
        <span style={{ fontWeight: "bold" }}>
          &nbsp;Değişmeden önceki şekli: 19-
        </span>
          &nbsp;
          <span style={{ fontWeight: "bold" }}>
          (2015/8353 sayılı Kararname ile eklenen sıra. Yürürlük: 1/1/2016)
        </span>
          &nbsp;Küspe (21/12/2015 tarihli ve 2015/8320 sayılı Bakanlar Kurulu
        Kararı ile yürürlüğe konulan İstatistik Pozisyonlarına Bölünmüş Türk
        Gümrük Tarife Cetveli'nin 2303.10 pozisyonunda yer alan nişastacılık
        artıkları ve benzeri artıklar ile 2303.30.00.00.00 pozisyonunda yer alan
        biracılık ve damıtık içki sanayinin posa ve artıkları hariç), tam yağlı
        soya (fullfat), kepek, razmol, balık unu, et unu, kemik unu, kan unu,
        tapiyoka (manyok), sorgum ve her türlü fenni karma yemler (kedi-köpek
        mamaları hariç), saman, yem şalgamı, hayvan pancarı, kök yemler, kuru
        ot, yonca, fiğ, korunga, hasıl ve slajlık mısır, üçgül, yemlik lahana,
        yem bezelyesi ve benzeri hayvan yemleri (yeşil ve kuru kaba yemler ve
        bunların pellet şeklinde veya mevsimsel ihtiyaçlara göre bir bağlayıcı
        kullanılarak veya kullanılmadan işlem görmüş olanları dahil)
      </em>{" "}
    </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
    <span style={{ fontSize: "x-small" }}>
      <span style={{ fontWeight: "bold" }}>
        <em>(**)</em>
      </span>
      <em>
        &nbsp;6663 sayılı Gelir Vergisi Kanunu ile Bazı Kanunlarda Değişiklik
        Yapılmasına Dair Kanun'un 13 üncü maddesi ile 3065 sayılı Katma Değer
        Vergisi Kanununun 13 üncü maddesinin 1 numaralı fıkrasına (ı) bendi
        eklenmek suretiyle, 2015/8353 sayılı Kararname ile eklenen (I) sayılı
        listenin 19 uncu ve 20 nci sıralarında yer alan ürünlerin teslimi
        10.02.2016 tarihinden geçerli olmak üzere istisna kapsamına alınmıştır.{" "}
      </em>{" "}
    </span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <strong>
                        (97) <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp; (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 6.maddesi ile
        değiştirilen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
    <span style={{ fontWeight: "bold" }}>
      (2008/13902 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      20/07/2008)&nbsp;
    </span>
                    18/12/2007 tarihli ve 2007/13007 sayılı Kararnamenin eki İstatistik
                    Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetvelinin;&nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}> (*) </span>
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2520.20.90.10.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Dişçilikte kullanılan alçılar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2520.20.90.90.11 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Tıpta kullanılan alçılar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2804.40.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Oksijen</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.20.00.11</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Radyoaktif iyot</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.20.00.12</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Radyoaktif fosfor</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.20.00.13</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Radyoaktif karbon</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.20.00.14</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Radyoaktif kobalt</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.20.00.19</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>2844.40.30.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Suni radyoaktif izotopların bileşikleri (EURATOM)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>30.01</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tedavide kullanılan kurutulmuş guddeler ve diğer organlar (toz
                                haline getirilmiş olsun olmasın); guddelerin veya diğer organların
                                veya bunların salgılarının tedavide kullanılan hülasaları; heparin
                                ve tuzları; tedavide veya korunmada kullanılmak üzere hazırlanmış
                                tarifenin başka yerinde yer almayan veya belirtilmeyen insan veya
                                hayvan menşeli diğer maddeler
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>30.05</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tıpta, cerrahide, dişçilikte veya veterinerlikte kullanılan
                                eczacılık maddeleri emdirilmiş veya kaplanmış veya perakende
                                satılacak şekilde hazırlanmış veya ambalajlanmış pamuklar, gaz
                                bezleri, bandajlar ve benzeri maddeler (sargılar, sparadralar,&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>&nbsp;hardal
                                yakıları gibi)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>30.06</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Bu fasılın 4 nolu notunda belirtilen eczacılık eşyası ve
                                müstahzarları
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>33.06</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Ağız veya diş sağlığını korumaya mahsus müstahzarlar (takma dişleri
                                temizlemeye ve onları ağızda sabit tutmaya mahsus pat ve tozlar
                                dâhil); diş aralarını temizlemekte kullanılan iplikler (diş
                                iplikleri), bireysel kullanıma mahsus ambalajlarda perakende
                                satılacak hale getirilmiş&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3307.90.00.90.11</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Kontakt-lens veya suni göz solüsyonları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3407.00.00.10.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Dişçilikte kullanılan alçı esaslı diğer müstahzarlar</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3407.00.00.90.11</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Dişçi mumu&nbsp;<span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3407.00.00.90.13</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Elastomer esaslı ölçü maddeleri (dişçilikte kullanılan)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3407.00.00.90.14</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Çinko oksit-öjenol esaslı ölçü maddeleri (dişçilikte kullanılan)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3701.10.10.00.00 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tıpta, dişçilikte veya veterinerlikte kullanılanlar&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3701.20.00.90.12</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Seluloitten veya diğer plastik maddelerden sağlık işlerinde
                                kullanılanlar
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3821.00.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Mikroorganizmaların (virüsler ve benzerleri), bitkilerin, insan veya
                                hayvan hücrelerinin geliştirilmesine veya idamesine mahsus müstahzar
                                kültür ortamları
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>3822.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Bir mesnet üzerinde bulunan laboratuvarlarda veya teşhiste
                                kullanılan reaktifler, bir mesned üzerinde olsun olmasın
                                laboratuvarlarda veya teşhiste kullanılan müstahzar reaktifler
                                (30.02 veya 30.06 pozisyonlarında yer alanlar hariç); standart
                                (referans) maddeleri
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>39. Fasıl</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Plastikler ve mamulleri&nbsp;(Yalnız idrar torbaları, kolostomi
                                torbaları, aseptik dolum torbaları, her nevi eldivenler, her nevi
                                kan alma tüpleri ve prezervatifler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>40. Fasıl</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Kauçuk ve kauçuktan eşya&nbsp;(Yalnız idrar torbaları, kolostomi
                                torbaları, aseptik dolum torbaları, her nevi eldivenler, her nevi
                                kan alma tüpleri ve prezervatifler)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>7015.10.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Numaralı gözlük camları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8419.20</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Tıbbi, cerrahi veya laboratuvar sterilizatörleri</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8421.29.00.00.11 (52)</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diyalizör</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8509.80.00.00.19</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri&nbsp;(Yalnız elektrikli - pilli diş fırçaları)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>90.11</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Kombine haldeki optik mikroskoplar (fotomikrografi,
                                sinefotomikrografi veya mikroprojeksiyon mikroskopları
                                dâhil)&nbsp;(Aksam, parça ve aksesuarlar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>90.18</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tıpta, cerrahide, dişçilikte ve veterinerlikte kullanılan alet ve
                                cihazlar (Sintigrafi cihazları, diğer elektromedikal cihazlar ve göz
                                testine mahsus cihazlar dahil)&nbsp;(Aksam ve parçalar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>90.19</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Mekanoterapi cihazları; masaj cihazları; psikotekni cihazları;
                                ozonoterapi, oksijenoterapi, aeroterapi, suni teneffüs veya diğer
                                terapik teneffüs cihazları&nbsp;(Aksam ve parçalar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9020.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğer teneffüs cihazları ve gaz maskeleri (Mekanik parçaları ve
                                değiştirilebilen filtreleri olmayan koruyucu maskeler
                                hariç)&nbsp;(Aksam, parça ve aksesuarlar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>90.21</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Ortopedik cihazlar (Koltuk değnekleri, cerrahi kuşaklar ve fıtık
                                bağları dahil); cebireler, gudyerler ve kırıklara mahsus diğer
                                cihazlar; protez organlar; sağırların&nbsp;
                                <span style={{ fontWeight: "bold" }}>(52)</span>&nbsp;işitmesini
                                kolaylaştırmaya mahsus cihazlar ve vücut kusur veya noksanlığını
                                gidermek amacıyla üstte veya elde taşınan veya vücudun içine
                                yerleştirilen diğer cihazlar (Aksam, parça ve aksesuarlar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9022.12.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Bilgisayarlı tomografi cihazları</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9022.13.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri (dişçiliğe mahsus olanlar)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9022.14</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğerleri (tıbbi, cerrahi veya veterinerlik amaçlı kullanımlar için)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9022.21</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Tıbbi, cerrahi, dişçilik veya veterinerlik amaçlı kullanımlar için
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9027.80</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğer alet ve cihazlar&nbsp;(Yalnız PCR cihazı, kan sayım,
                                nefelometre vb. analiz ve ölçüm cihazları, biokimya, idrar ve eliza
                                cihazları)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9402.10.00.00.11</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Dişçi&nbsp;<span style={{ fontWeight: "bold" }}>(52)</span>
                                &nbsp;koltukları
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9402.90</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri&nbsp;(Aksam ve parçalar hariç)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9506.91.90.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Diğerleri&nbsp;(Yalnız yürüteç barı vb.)</p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9603.21.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diş fırçaları&nbsp;<span style={{ fontWeight: "bold" }}>(52)</span>
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    <span style={{ fontWeight: "bold" }}>(**)</span>
                </p>
                <table cellSpacing={0} cellPadding={0} border={1}>
                    <tbody>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9001.30.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Kontak lensler (Yalnız görme kusurunun giderilmesine mahsus olanlar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9001.40</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Camdan gözlük camları (Yalnız görme kusurunun giderilmesine mahsus
                                olanlar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9001.50</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğer maddelerden gözlük camları (Yalnız görme kusurunun
                                giderilmesine mahsus olanlar)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>90.03</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Gözlüklere veya benzeri eşyaya ait çerçeveler ve bunların aksam ve
                                parçaları (Kıymetli metallerden veya kıymetli metallerle kaplama
                                metallerden olan gözlük çerçeveleri ve gözlük benzeri eşyaya ait
                                çerçeveler ile bunların aksam ve parçaları hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9004.10.10.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Optik tarzda işlenmiş camlı olanlar (Çerçevesi kıymetli metallerden
                                veya kıymetli metallerle kaplama metallerden olanlar hariç)
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>9004.90</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>
                                Diğerleri (Çerçevesi kıymetli metallerden veya kıymetli metallerle
                                kaplama metallerden olanlar hariç)
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    pozisyonlarında yer alan eşyaların teslimi &nbsp;ile bunlardan makine ve
                    cihaz niteliği taşıyanların kiralanması hizmetleri,&nbsp;
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <span style={{ fontWeight: "bold" }}>
        <em>(*)</em>
      </span>
      <em>
        &nbsp;
          <span style={{ fontWeight: "bold" }}>
          (2008/13902 sayılı BKK ile değişmeden önceki şekli)
        </span>
          &nbsp;22- Tıbbi cihazlar (Sağlık Bakanlığı tarafından yayımlanan "Tıbbi
        Cihaz Yönetmeliği", "Vücuda Yerleştirilebilir Aktif Tıbbi Cihazlar
        Yönetmeliği" ve "Vücut Dışında Kullanılan Tıbbi Tanı Cihazları
        Yönetmeliği" kapsamında tanımları verilen ve doğrudan sağlık hizmetleri
        ile veterinerlikte kullanılan cihazlar, bunların aksam ve parçaları) ile
        bunların kiralanması hizmetleri,{" "}
      </em>{" "}
    </span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <em>
        <span style={{ fontWeight: "bold" }}>
          (**)&nbsp;(2008/14092 sayılı BKK ile eklenen satırlar. Yürürlük:
          21/09/2008
        </span>
        ){" "}
      </em>{" "}
    </span>
                </p>
                <p>
                    <strong>
                        (98) Kaldırılmadan önceki şekli :&nbsp; (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 7.maddesi ile
        kaldırılan ibare
      </span>
                        ;
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>
                    &nbsp;(birinci sınıf lokanta ruhsatı ya da işletme belgesine sahip olan
                    yerler ile üç yıldız ve üzeri oteller, tatil köyleri ve benzeri tesislerin
                    bünyesindeki lokantalar hariç)&nbsp;
                    <span style={{ fontWeight: "bold" }}>(*)</span>
                </p>
                <p>
    <span style={{ fontSize: "x-small" }}>
      <span style={{ fontWeight: "bold" }}>
        <em>(*)</em>
      </span>
      <em>
        &nbsp;
          <span style={{ fontWeight: "bold" }}>
          (2009/15200 sayılı BKK ile eklenen ibare. Yürürlük: 15/07/2009)&nbsp;
        </span>
        (birinci sınıf lokanta ruhsatı ya da işletme belgesine sahip olan yerler
        ile üç yıldız ve üzeri oteller, tatil köyleri ve benzeri tesislerin
        bünyesindeki lokantalar hariç)
      </em>{" "}
    </span>
                </p>
                <p>
                    <strong>
                        (99) <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp; (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 8.maddesi ile
        değiştirilen satır
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>
                </p>
                <table border={1} cellPadding={0} cellSpacing={0}>
                    <tbody>
                    <tr>
                        <td width={163} valign="top">
                            <p>
                                <span style={{ fontWeight: "bold" }}>8434.10.00.00.00</span>
                            </p>
                        </td>
                        <td width={473} valign="top">
                            <p>Süt sağma makinaları</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p>
                    <strong>(100)</strong>
                    <strong>
                        {" "}
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 8.maddesi ile;
        30/12/2021 tarihli ve 5045 sayılı Cumhurbaşkanı Kararı eki İstatistik
        Pozisyonlarına Bölünmüş Türk Gümrük Tarife Cetveline göre eklenen
        sıralar
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022)
      </span>
                    </strong>
                </p>
                <p>
                    <strong>
                        (101){" "}
                        <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;
                    </strong>{" "}
                    <span style={{ fontWeight: "bold" }}>
      <span>
        (6790 sayılı Cumhurbaşkanı Kararıyla eklenen geçici madde; Yürürlük:
        15.02.2023)
      </span>
                        &nbsp;{" "}
    </span>{" "}
                    Prefabrik yapı ile konteynerlerin, 8/2/2023 tarihli ve 6785 sayılı
                    Cumhurbaşkanı Kararı ile olağanüstü hal ilan edilen illerde kullanılmak
                    üzere 31/12/2023 tarihine kadar (bu tarih dahil) afetzedeler ile 3065 sayılı
                    Katma Değer Vergisi Kanununun 17 nci maddesinin birinci fıkrasında sayılan
                    kurum ve kuruluşlara tesliminde (kurulum ve montaj işleri dahil), bu Kararın
                    1 inci maddesinin birinci fıkrasının (b) bendinde belirtilen vergi oranı
                    uygulanır.
                </p>
                <p>
                    <strong>
                        (102){" "}
                        <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;
                    </strong>
                    &nbsp;% 18
                </p>
                <p>
                    <strong>
                        (103){" "}
                        <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;
                    </strong>
                    % 8
                </p>
                <p>
                    <strong>
                        (104){" "}
                        <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                        &nbsp;
                    </strong>{" "}
                    <strong>
                        (
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        29/03/2022 tarihli ve 5359 sayılı Cumhurbaşkanı Kararı 9.maddesi ile
        eklenen sıra
      </span>
                        <span style={{ fontWeight: "bold" }}>;</span>
                        <span style={{ textAlign: "justify", fontWeight: "bold" }}>
        &nbsp;Yürürlük: 01/04/2022){" "}
      </span>
                    </strong>
                    Sabun, şampuan, deterjan, dezenfektanlar, ıslak mendil (sabun, deterjan veya
                    solüsyon emdirilmiş olsun olmasın), tuvalet kağıdı, kağıt havlu, kağıt
                    mendil ve peçete, diş fırçası ve macunu, diş iplikleri,
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    <strong>(105)</strong>&nbsp;
                    <span style={{ fontWeight: "bold" }}>Değişmeden önceki şekli :</span>
                    <span style={{ fontWeight: "bold" }}>&nbsp;</span>{" "}
                    <span style={{ fontWeight: "bold" }}>
      {" "}
                        (2012/2931 sayılı Kararname ile değiştirilen sıra. Yürürlük:
      25/03/2012)&nbsp;{" "}
    </span>{" "}
                    Sağlık Bakanlığı tarafından ruhsatlandırılan veya ithaline izin verilen
                    beşeri tıbbi ürünler, bu ürünlerin terkibinde bulunan etkin maddeler ve
                    etkin madde üretiminde kullanılan hammaddeler,&nbsp;
                    <span style={{ fontWeight: "bold" }}>(22)</span>
                </p>
                <p align="center" style={{ textAlign: "justify" }}>
                    &nbsp;
                </p>
            </div>

        </Container>
    );
};

export default KdvOranlari;